import { Component, OnInit, ViewChild, Output, EventEmitter, ɵConsole } from '@angular/core';
import { ContenedorMpComponent } from '../../MedidasProt/contenedor-mp/contenedor-mp.component';
import { DenunciaContenedorComponent } from '../../denuncia/denuncia-contenedor/denuncia-contenedor.component';
import { ContenedorDenuncianteComponent } from '../../Denunciante/Contenedor/contenedor-denunciante.component';
import { DatosGeneralComponent } from '../../datos-general/datos-general.component';
import { Fur } from 'src/app/models/Fur';
import { Persona } from 'src/app/models/Persona';
import { MformularioWebC } from 'src/app/models/personalizados/MformularioWebC';
import { FurService } from 'src/app/services/fur.service';
import { MatDialog } from '@angular/material/dialog';
import { PersonaNaturalComponent } from '../../Denunciante/PersonaNatural/persona-natural.component';
import {
  ConvertirFlag,
  openModalMensaje,
  ValidarEmail,
  GetDateTime,
  correoEmisor,
  NumIdEstadoHeEvaluacionSuperv,
  NumIdEstadoHeEvaluacionObservado,
  codigoIncial,
  anioActualGlobal,
  gvCanal,
  NumIdEstadoRegistrado,
  NumIdEstadoBorrador,
  getBooleanFlag,
  NumIdParamDiasVenc,
  isEmpty,
  NumIdParamRutaArchGen,
  NumIdCatTipoPD,
  CargarDatosPlantilla,
  NumIdCatNombrPlantFW,
  NumIdCatDocGenFW,
  RecupObjDatosPlant,
  saveContent,
  CodTipoFichaFUR,
  CodSubTipoFichaOFI,
  DscNombreFileOficioFUR,
  isNotEmpty,
  NumIdTipCatCampPlantFW,
  CodTipDocPDF,
  NumIdParamRutaArchPlan,
  recupDscTipoInstancia,
  GetAnho,
  GetMes,
  ConvertDateTimeToStr,
  ConvertStrDateToFormatBD,
  DscNomDoc,
  horaAMPM,
  letraCapital,
  NumIdCatTipoPDEntidad,
  NumIdCatNombrPlantFWEnt,
  NumIdCatDocGenFWEnt,
  NumIdCatTipoPDAgrupPJ,
  NumIdCatNombrPlantFWAPJ,
  NumIdCatDocGenFWAPJ,
  NumIdCatTipoPDCON,
  NumIdCatNombrPlantFWCON,
  NumIdCatDocGenFWCON,
  DscDenuncAnonimo,
  NumIdInforRecib,
  DscMensajeSpinner,
  recupContenidoEmail,
  DscMensajeSpinner2,
  NumIdMedioNotifEmail,
  GlobalVars,
  cookieGlobalVars,
  cambiarRouter,
  ParametroVars,
  ConvertirFlagPre
} from 'src/app/general/variables';
import { Denunciante } from 'src/app/models/Denunciante';
// import { DenuncianteXFamiliar } from 'src/app/models/DenuncianteXFamiliar';
import { FurXObraPublica } from 'src/app/models/FurXObraPublica';
import { DenunciadoXFicha } from 'src/app/models/DenunciadoXFicha';
import { FURXEmpresaInvolucrada } from 'src/app/models/FURXEmpresaInvolucrada';
// import { EvaluacionPreliminarService } from 'src/app/services/bpm/evaluacion-preliminar.service';
import { Oficio } from 'src/app/models/BPM/oficio';
import { DocumentoCGR } from 'src/app/models/DocumentoCGR';
import { AtributoCGR } from 'src/app/models/AtributoCGR';
import { ModalGuardarComponent } from '../modal-guardar/modal-guardar.component';
import { ModalMensaje } from 'src/app/models/ModalMensaje';
import { General } from 'src/app/models/General';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParametroService } from 'src/app/services/parametro.service';
import { DenuncianteXRepLegal } from 'src/app/models/DenuncianteXRepLegal';
import { FichaXContratacion } from 'src/app/models/FichaXContratacion';
import { CatalogoService } from 'src/app/services/Catalogo.service';
import { PDDatos } from 'src/app/models/PDDatos';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { PlantillaDocumento } from 'src/app/models/PlantillaDocumento';
import { Observable } from 'rxjs/internal/Observable';
import { DocumentoDet } from 'src/app/models/DocumentoDet';
import { CorreoBpm } from 'src/app/models/CorreoBpm';
import { CorreoDetalleBpm } from 'src/app/models/CorreoDetalleBpm';
import { DatosGenFurComponent } from '../../fur/datos-gen-fur/datos-gen-fur.component';
import { PDTabla } from 'src/app/models/PDTabla';
import { PDFila } from 'src/app/models/PDFila';
import { FichaXInstancia } from 'src/app/models/FichaXInstancia';
import { AsignarInfoBPMService } from 'src/app/services/bpm/asignar-info.service';
import { RequestNewInstanceGC } from 'src/app/models/BPM/RequestNewInstanceGC';
import { PersonaXRepLeg } from 'src/app/models/PersonaXRepLeg';
import { FrmFURPorCodigoBorrador } from 'src/app/models/FrmFURPorCodigoBorrador';
import { InfoComplementariaWebComponent } from '../../info-complementaria-web/info-complementaria-web.component';
import { Router } from '@angular/router';
import { BandejaNotifComponent } from '../../bandeja-notif/bandeja-notif.component';
import { DatosMovilComponent } from '../../datos-movil/datos-movil.component';

@Component({
  selector: 'app-contenedor-web',
  templateUrl: './contenedor-web.component.html',
  styleUrls: ['./contenedor-web.component.css']
})
export class ContenedorWebComponent implements OnInit {

  strDscMensajeSpinner = '';
  flgTabInfCompl = false;
  flgTabBandeja = false;
  flgTabMovil = false;


  @ViewChild(DenunciaContenedorComponent) denunciaContenedorC: DenunciaContenedorComponent;
  @ViewChild(ContenedorDenuncianteComponent) contenedorDenuncianteC: ContenedorDenuncianteComponent;
  @ViewChild(ContenedorMpComponent) contenedorMpC: ContenedorMpComponent;
  @ViewChild(DatosGeneralComponent) datosGeneralC: DatosGeneralComponent;
  @ViewChild(DatosGenFurComponent) datosGenFurC: DatosGenFurComponent;
  @ViewChild(InfoComplementariaWebComponent) InfoComplementariaWebC: InfoComplementariaWebComponent;
  @ViewChild(BandejaNotifComponent) BandejaNotifC: BandejaNotifComponent;
  @ViewChild(DatosMovilComponent) DatosMovilC: DatosMovilComponent;



  @Output() guardarEmitter = new EventEmitter();
  @Output() guardarInfoComplEmitter = new EventEmitter();

  flgRecupBorrador = false;


  tabDenunciante = false;
  tabProteccion = false;
  flgTransicionTab = true;
  fur: Fur = null;
  flgEnviarDenuncia = false;
  flgGuardarBorrador = false;
  flgActivaEncuesta = false;
  numDiasVencimiento: number = null;
  strDscNombrPlantillaEnt: string = null;
  strDscNomArchivoGenEnt: string = null;
  strDscNombrPlantillaAPJ: string = null;
  strDscNomArchivoGenAPJ: string = null;
  strDscNombrPlantillaCON: string = null;
  strDscNomArchivoGenCON: string = null;


  persona: Persona = new Persona();
  personaCompl: Persona;
  flgDeshabilitaGuardar = false;
  flgViewDatosGen = true;
  // cuniCodigo:string;
  // datosGeneral : DatosGeneral ;//= new DatosGeneral();
  mFormularioWebC: MformularioWebC;
  // CUS04 - 06
  flgEsFud = false; // Para cuando es fud solo se debe mostrar los datos de la primera pestaña
  // furNew : Fur = new Fur();
  oficio: Oficio = new Oficio();
  strFchHorInicioReg: string = GetDateTime(0, 0);
  documentoCGR: DocumentoCGR = new DocumentoCGR();
  strDscRutaArchivoPlant: string = null;
  strDscRutaArchivoGen: string = null;
  strDscNomArchivoGen: string = null;
  strDscNombrPlantilla: string = null;
  pdDatos: PDDatos[] = [];
  generalParams: General;
  strDscEnlaceApp = '';
  strDscEnlaceDocEmail = '';


  flgFur = false;

  constructor(protected furService: FurService,
              public dialog: MatDialog,
              public dialogGuardar: MatDialog,

              private spinner: NgxSpinnerService,
              protected parametroService: ParametroService,
              protected catalogoService: CatalogoService,
              protected externosService: ExternosService,
              protected asignarInfoBPMService: AsignarInfoBPMService,
              public router: Router

    ) { }

  ngOnInit() {

    this._CambiarTextoSpinner(1);

    // console.log("=====horaAM",horaAMPM(null)) ;

    this.parametroService.obtenerParametro(NumIdParamDiasVenc).subscribe(data => {



      if (data) {

        this.numDiasVencimiento = data.nparamValor;

      }



    });

    this.parametroService.obtenerParametro(NumIdParamRutaArchPlan).subscribe(
      data => {

        if (data) {

          this.strDscRutaArchivoPlant = data.cparamValor;

        }



      });


    this.parametroService.obtenerParametro(NumIdParamRutaArchGen).subscribe(
      data => {

        if (data) {

          this.strDscRutaArchivoGen = data.cparamValor;
        }



      });

    this.catalogoService.listarCatalogo(NumIdCatTipoPD).subscribe(
      data => {

        if (data) {

          this.strDscNombrPlantilla = "data";
          this.strDscNomArchivoGen = "data";
        }



      });

    this.catalogoService.listarCatalogo(NumIdCatTipoPDEntidad).subscribe(
      data => {

        if (data) {

          this.strDscNombrPlantillaEnt = "data";
          this.strDscNomArchivoGenEnt = "data";
        }

      });

    this.catalogoService.listarCatalogo(NumIdCatTipoPDAgrupPJ).subscribe(
      data => {

        if (data) {

          this.strDscNombrPlantillaAPJ  = "dato";
          this.strDscNomArchivoGenAPJ = "dato"
        }

      });

    this.catalogoService.listarCatalogo(NumIdCatTipoPDCON).subscribe(
      data => {

        if (data) {

          this.strDscNombrPlantillaCON = "data";
          this.strDscNomArchivoGenCON = "data";
        }

      });

    this.catalogoService.listarCatalogo(NumIdTipCatCampPlantFW).subscribe(
      data => {

        if (data) {

          this.pdDatos = CargarDatosPlantilla(data);

        }



      });



    this.strDscEnlaceApp = ParametroVars.Param17;




    this.strDscEnlaceDocEmail = ParametroVars.Param26;



  }

  _cargarDatosMovil() {

    this.DatosMovilC.cargarDatosMovil();

  }

  _SelectTabDenunciante() {

    document.getElementById('aTabDenun').click();


  }

  _SelectTabDenuncia() {

    document.getElementById('aTabDenuncia').click();


  }

  _SelectTabMDP() {

    document.getElementById('aTabMP').click();


  }


  validarGuardarInfoCompl() {

    return this.InfoComplementariaWebC.validarGuardar();

  }

  guardarInfoCompl() {

    this._CambiarTextoSpinner(2);

    this.InfoComplementariaWebC.guardar();

  }

  _guardadoInfoCompl(dataReturn: General) {

    this._CambiarTextoSpinner(1);


    this.guardarInfoComplEmitter.emit(dataReturn);

  }



  setGeneralParams(gparams: General) {

    this.generalParams = new General();

    this.generalParams.numCampo1 = gparams.numCampo1;
    this.generalParams.flgCampo1 = gparams.flgCampo1;

    // console.log("this.generalParams",this.generalParams);

  }

  _getAriaSelectedTab(numTab: number) {

    let vFlgReturn = false;

    switch (numTab) {
      case 1:

        vFlgReturn = this.flgFur;

        break;

      case 2:

        vFlgReturn = !this.flgFur;

        break;

      default:
        break;
    }

    return vFlgReturn;

  }

  setFlgFur(flgValor: boolean) {

    this.flgFur = flgValor;

  }

  _generarPDFilas(dato: string, listFila: PDFila[]) {

    let vItemFila: PDFila = null;

    vItemFila = new PDFila();
    vItemFila.valor = (dato ? dato.trim() : '');

    listFila.push(vItemFila);

    return listFila;

  }

  _generarPDGrillas(itemGrilla: PDTabla, lista: any, col: string, ubic: string) {

    const nFilas: string = (lista ? lista.length.toString() : '0');

    itemGrilla = new PDTabla();

    itemGrilla.columnas = col;
    itemGrilla.nombre = '0';
    itemGrilla.ubicacion = ubic;
    // itemGrilla.nuevasFilas = lista.length.toString();
    itemGrilla.nuevasFilas = nFilas;

    itemGrilla.filas = [];

    return itemGrilla;

  }

  _generarGrillasPlantillaDoc(fur: Fur) {

    const vListGrilla: PDTabla[] = [];
    let vItemGrilla: PDTabla = null;

    // var vItemGrilla:PDTabla = null;

    const vListDenunciado: DenunciadoXFicha[] = fur.listaDenunciadoPorFicha;
    const vListDocumentoDet: DocumentoDet[] = fur.listaDocumentoAdjuntoDet;
    const vListFichaPorInst: FichaXInstancia[] = fur.listaFichaPorInstancia;
    const vListFichaPorEmpre: FURXEmpresaInvolucrada[] = fur.listaFurPorEmpresaInvolucrada;
    const vListFichaPorContrat: FichaXContratacion[] = fur.listaFichaPorContratacion;
    const vListFurPorObraPublica: FurXObraPublica[] = fur.listaFurPorObraPublica;
    let vListRepreLegalCompl: PersonaXRepLeg[] = null;
    let strDscRepLegal = '';
    const strSeparador = ', ';

    if (fur.denunciante) {

      if (fur.denunciante.personaComplemento) {

        if (fur.denunciante.personaComplemento.listaPersonaPorReplegal) {

          vListRepreLegalCompl = fur.denunciante.personaComplemento.listaPersonaPorReplegal;

        }

      }

    }

    const formatToCurrency = amount => {
      return 'S/' + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    };

    if (vListFichaPorContrat) {

      vItemGrilla = this._generarPDGrillas(vItemGrilla, vListFichaPorContrat, '6', '4');

      vListFichaPorContrat.forEach((element, index) => {

        index ++;

        vItemGrilla.filas = this._generarPDFilas(index.toString(), vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(element.contratacion.ccontratacionNroselecc, vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(letraCapital(element.contratacion.ccontratacionDscobjcont), vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(letraCapital(element.contratacion.ccontratacionDscobjeto), vItemGrilla.filas);

        if (element.contratacion.ncontratacionImpmonto) {
          // vItemGrilla.filas = this._generarPDFilas(element.contratacion.ncontratacionImpmonto.toString(),vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas(formatToCurrency(element.contratacion.ncontratacionImpmonto), vItemGrilla.filas);
        } else {
          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);
        }

        if (element.listaFichaPorContratacionPorHechoIrregular) {

          vItemGrilla.filas = this._generarPDFilas((element.listaFichaPorContratacionPorHechoIrregular.length > 0 ? 'Si' : 'No'), vItemGrilla.filas);

        } else {

          vItemGrilla.filas = this._generarPDFilas('No', vItemGrilla.filas);

        }

      });

      vListGrilla.push(vItemGrilla);

    }

    if (vListFurPorObraPublica) {

      vItemGrilla = this._generarPDGrillas(vItemGrilla, vListFurPorObraPublica, '7', '5');

      vListFurPorObraPublica.forEach((element, index) => {

        index ++;

        vItemGrilla.filas = this._generarPDFilas(index.toString(), vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(letraCapital(element.obraPublica.cobrapublicaDscnombre), vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(letraCapital(element.obraPublica.cobrapublicaDscestado), vItemGrilla.filas);

        if (element.obraPublica.nobrapublicaCosto) {
          vItemGrilla.filas = this._generarPDFilas(formatToCurrency(element.obraPublica.nobrapublicaCosto), vItemGrilla.filas);
        } else {
          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);
        }


        if (element.obraPublica.strDobrapublicaFechaini) {

          vItemGrilla.filas = this._generarPDFilas(element.obraPublica.strDobrapublicaFechaini.substring(0, 10), vItemGrilla.filas);

        } else {

          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);

        }

        if (element.obraPublica.strDobrapublicaFechafin) {

          vItemGrilla.filas = this._generarPDFilas(element.obraPublica.strDobrapublicaFechafin.substring(0, 10), vItemGrilla.filas);

        } else {

          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);

        }

        if (element.listaFurPorObraPubPorHechoIrr) {

          vItemGrilla.filas = this._generarPDFilas((element.listaFurPorObraPubPorHechoIrr.length > 0 ? 'Si' : 'No'), vItemGrilla.filas);

        } else {

          vItemGrilla.filas = this._generarPDFilas('No', vItemGrilla.filas);

        }



      });

      vListGrilla.push(vItemGrilla);

    }

    if (vListDenunciado) {

      vItemGrilla = this._generarPDGrillas(vItemGrilla, vListDenunciado, '7', '8');

      vListDenunciado.forEach((element, index) => {

        index ++;

        vItemGrilla.filas = this._generarPDFilas(index.toString(), vItemGrilla.filas);

        if (element.denunciado) {

          vItemGrilla.filas = this._generarPDFilas(element.denunciado.cdenunciadoNrodoc, vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas(letraCapital(element.denunciado.cdenunciadoNombres), vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas(letraCapital(element.denunciado.cdenunciadoApepaterno), vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas(letraCapital(element.denunciado.cdenunciadoApematerno), vItemGrilla.filas);

          if (element.denunciado.cargo) {

            vItemGrilla.filas = this._generarPDFilas(letraCapital(element.denunciado.cargo.ccargoDsc), vItemGrilla.filas);

          } else {

            vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);

          }


          vItemGrilla.filas = this._generarPDFilas(letraCapital(element.denunciado.cdenunciadoFlgpermentidad), vItemGrilla.filas);

        } else {

          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);


        }



      });

      vListGrilla.push(vItemGrilla);

    }

    /// MPRESAS INVO

    if (vListFichaPorEmpre) {

      vItemGrilla = this._generarPDGrillas(vItemGrilla, vListFichaPorEmpre, '5', '10');

      vListFichaPorEmpre.forEach((element, index) => {

        index ++;
        strDscRepLegal = '';

        vItemGrilla.filas = this._generarPDFilas(index.toString(), vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(element.persona.cpersonaNrodoc, vItemGrilla.filas);
        // vItemGrilla.filas = this._generarPDFilas(letraCapital(element.persona.cpersonaRazonsocial),vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(element.persona.cpersonaRazonsocial, vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(letraCapital(element.persona.cpersonaDscdireccion), vItemGrilla.filas);

        if (element.persona.listaPersonaPorReplegal) {

          element.persona.listaPersonaPorReplegal.forEach(element1 => {

            strDscRepLegal = strDscRepLegal + element1.cpersonaxrlNombres + strSeparador;

          });

          strDscRepLegal = (strDscRepLegal ? strDscRepLegal : '');

          if (strDscRepLegal.length > 0) {

            strDscRepLegal = strDscRepLegal.substr(0, strDscRepLegal.lastIndexOf(strSeparador));

          }

        }

        // vItemGrilla.filas = this._generarPDFilas(letraCapital(element.persona.cpersonaDscreprelegal),vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(letraCapital(strDscRepLegal), vItemGrilla.filas);

      });

      vListGrilla.push(vItemGrilla);

    }




    ///////////////////////////// EVIDENCIAS
    if (vListDocumentoDet) {

      vItemGrilla = this._generarPDGrillas(vItemGrilla, vListDocumentoDet, '4', '12');

      vListDocumentoDet.forEach((element, index) => {

        index ++;

        vItemGrilla.filas = this._generarPDFilas(index.toString(), vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(element.cdocumentoDscnombre, vItemGrilla.filas);

        // console.log("====element.strDdocumentoFchreg",element);

        if (element.strDdocumentoFchregAMPM) {

          // vItemGrilla.filas = this._generarPDFilas(element.strDdocumentoFchreg.substr(0,10) + " " + horaAMPM(element.ddocumentoFchreg),vItemGrilla.filas);
          vItemGrilla.filas = this._generarPDFilas(element.strDdocumentoFchregAMPM, vItemGrilla.filas);

        } else {

          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);
        }


        vItemGrilla.filas = this._generarPDFilas('Registrado', vItemGrilla.filas);


      });

      vListGrilla.push(vItemGrilla);

    }


    ///////////////////////////// INSTANCIAS
    if (vListFichaPorInst) {

      vItemGrilla = this._generarPDGrillas(vItemGrilla, vListFichaPorInst, '6', '14');

      vListFichaPorInst.forEach((element, index) => {

        index ++;

        vItemGrilla.filas = this._generarPDFilas(index.toString(), vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(recupDscTipoInstancia(element.cfichaxinstanCodtipo), vItemGrilla.filas);
        // vItemGrilla.filas = this._generarPDFilas(letraCapital(element.entidad.centNombre),vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(element.entidad.centNombre, vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(element.cfichaxinstanNrodoc, vItemGrilla.filas);

        if (element.strDfichaxinstanFechaprest) {

          vItemGrilla.filas = this._generarPDFilas(element.strDfichaxinstanFechaprest.substr(0, 10) + ' ' + horaAMPM(element.dfichaxinstanFchPresent) , vItemGrilla.filas);

        } else {

          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);

        }

        if (element.estado) {

          vItemGrilla.filas = this._generarPDFilas(letraCapital(element.estado.ccatalogoDsc), vItemGrilla.filas);

        } else {

          vItemGrilla.filas = this._generarPDFilas('', vItemGrilla.filas);

        }



      });

      vListGrilla.push(vItemGrilla);



    }

    if (vListRepreLegalCompl) {

      vItemGrilla = this._generarPDGrillas(vItemGrilla, vListRepreLegalCompl, '2', '18');

      vListRepreLegalCompl.forEach((element, index) => {

        index ++;

        vItemGrilla.filas = this._generarPDFilas(index.toString(), vItemGrilla.filas);
        // vItemGrilla.filas = this._generarPDFilas("",vItemGrilla.filas);
        vItemGrilla.filas = this._generarPDFilas(letraCapital(element.cpersonaxrlNombres), vItemGrilla.filas);

      });

      vListGrilla.push(vItemGrilla);

    }



    return vListGrilla;

  }

  _generarPlantilla(numIdFur: number, furNew: Fur, flgProcLF?: boolean) {

    // var vListGeneralFinal:General[] = [];
    const vPlantillaDocumento: PlantillaDocumento = new PlantillaDocumento();
    const vListDocumentoDet: DocumentoDet[] = [];
    let vFur: Fur = null;
    const vGeneralReturn: General = new General();
    const strCodBorrador = furNew.cfurCodborrador;
    const cfurClavedenunc = furNew.cfurClavedenunc;
    let flgEvidencia = false;
    let nombreArchPlant: string = this.strDscNombrPlantilla;
    let nombreArchPlantGen: string = this.strDscNomArchivoGen;
    let numCasoPlant = 0;

    flgProcLF = (flgProcLF == null ? true : false);

    vPlantillaDocumento.datos = [];

    const plantillaObservable = new Observable<General>(observer => {

      vFur = furNew;

      // SPAGHETTI DE DATOS

      this.pdDatos = RecupObjDatosPlant(vFur, this.pdDatos);

      // PROVISIONAL

      this.pdDatos.forEach(element => {

        if (element.valor == 'SI' || element.valor == 'NO') {

          element.valor = letraCapital(element.valor);

        }

      });

      let numIndex = this.pdDatos.findIndex(x => x.nombre == 'COD_BORRADOR1');

      // this.pdDatos[numIndex].valor =  this.pdDatos[numIndex].valor.substr(0,7);
      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  strCodBorrador; // this.pdDatos[numIndex].valor;

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'COD_BORRADOR2');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  this.pdDatos[numIndex].valor.substr(7);

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'CLAVE');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  cfurClavedenunc;

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'NOM_SEDE');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  'Sede Central Lima';

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'FLAG_DATEMP');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  'No';

        if (furNew.listaFurPorEmpresaInvolucrada) {

           if (furNew.listaFurPorEmpresaInvolucrada.length > 0) {

              this.pdDatos[numIndex].valor =  'Si';

           }

        }

      }



      numIndex = this.pdDatos.findIndex(x => x.nombre == 'COD_BORRADOR');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  strCodBorrador;

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'COD_PROT');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  strCodBorrador;

      }



      numIndex = this.pdDatos.findIndex(x => x.nombre == 'HOR_IMPRE');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  horaAMPM(null);

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'HORA_REG_DEN');

      // console.log("====horaAMPM(furNew.dfurFecregistro)",horaAMPM(furNew.dfurFecregistro));

      // return;

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  horaAMPM(furNew.dfurFecregistro);



      }



      numIndex = this.pdDatos.findIndex(x => x.nombre == 'FECHA_INI_PER');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor = '';

        if (furNew.strDfurFeciniperiodo) {
          this.pdDatos[numIndex].valor = furNew.strDfurFeciniperiodo.substr(0, 10);
        }


      }


      numIndex = this.pdDatos.findIndex(x => x.nombre == 'FECHA_FIN_PER');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  '';

        if (furNew.strDfurFecfinperiodo) {

          this.pdDatos[numIndex].valor =  furNew.strDfurFecfinperiodo.substr(0, 10);

        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'NRO_EXP');

      if (numIndex >= 0) {

        this.pdDatos[numIndex].valor =  '';

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'TIP_DOCIDENT');

      if (numIndex >= 0) {

        if (vFur.denunciante) {
          if (vFur.denunciante.persona) {

            if (vFur.denunciante.persona.tipoDocumento) {

              this.pdDatos[numIndex].valor =  vFur.denunciante.persona.tipoDocumento.ctipdocumentoDsc ;

            }

          }
        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'RANG_EDAD');

      if (numIndex >= 0) {

        if (vFur.cdenuncianteDscrangoedad) {
          this.pdDatos[numIndex].valor =  vFur.cdenuncianteDscrangoedad;
        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'NRO_DOCIDENT');

      if (numIndex >= 0) {

        if (vFur.denunciante) {
          if (vFur.denunciante.persona) {

            if (vFur.denunciante.persona.cpersonaNrodoc) {

              this.pdDatos[numIndex].valor =  vFur.denunciante.persona.cpersonaNrodoc;

            }

          }
        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'NOM_DENUNCIANTE');

      if (numIndex >= 0) {

        if (vFur.denunciante) {
          if (vFur.denunciante.persona) {

            if (vFur.denunciante.persona.cpersonaNombres) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.persona.cpersonaNombres);

            }

          }
        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'APE_PATER');

      if (numIndex >= 0) {

        if (vFur.denunciante) {
          if (vFur.denunciante.persona) {

            if (vFur.denunciante.persona.cpersonaApepaterno) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.persona.cpersonaApepaterno);

            }

          }
        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'APE_MATER');

      if (numIndex >= 0) {

        if (vFur.denunciante) {
          if (vFur.denunciante.persona) {

            if (vFur.denunciante.persona.cpersonaApematerno) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.persona.cpersonaApematerno);

            }

          }
        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'MAIL_DENUNCIANTE');

      if (numIndex >= 0) {

        if (vFur.denunciante) {

          this.pdDatos[numIndex].valor = vFur.denunciante.cdenuncianteDsccorreo ? vFur.denunciante.cdenuncianteDsccorreo : '';
        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'TIP_HI');

      if (numIndex >= 0) {

        if (vFur.cmacroprocesoDsc) {

          this.pdDatos[numIndex].valor = vFur.cmacroprocesoDsc;

        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'DSC_HI');

      if (numIndex >= 0) {

        if (vFur.cfurDschecho) {
          this.pdDatos[numIndex].valor = vFur.cfurDschecho;
        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'DSC_ENTEHECHO');

      if (numIndex >= 0) {

        if (vFur.denunciante) {

          if (vFur.denunciante.cdenuncianteDscenterohecho) {

            this.pdDatos[numIndex].valor = vFur.denunciante.cdenuncianteDscenterohecho;

          }

        }

      }



      numIndex = this.pdDatos.findIndex(x => x.nombre == 'ENT_PUB_DEN');

      if (numIndex >= 0) {

        if (vFur.entidad) {

          this.pdDatos[numIndex].valor = (vFur.entidad.centNombre ? vFur.entidad.centNombre : '').substr(0, 41);

        }

      }

      numIndex = this.pdDatos.findIndex(x => x.nombre == 'ENT_PUB_DEN2');

      if (numIndex >= 0) {

        if (vFur.entidad) {

          this.pdDatos[numIndex].valor = (vFur.entidad.centNombre ? vFur.entidad.centNombre : '').substr(41).trim();

        }

      }

      ////////////// descomentar


      // furNew.strDfurFeciniperiodo;

      // PROVISIONAL

      // console.log("===========this.pdDatos");
      // console.log(this.pdDatos);

      if (vFur.denunciante) {

        if (vFur.denunciante.ndenuncianteIdtipden == 6) {

          nombreArchPlant = this.strDscNombrPlantillaEnt;
          nombreArchPlantGen = this.strDscNomArchivoGenEnt;

          numCasoPlant = 2;

        } else if (vFur.denunciante.ndenuncianteIdtipden == 4) {

          nombreArchPlant = this.strDscNombrPlantillaCON;
          nombreArchPlantGen = this.strDscNomArchivoGenCON;

          numCasoPlant = 2;

        } else if (vFur.denunciante.ndenuncianteIdtipden == 2 || vFur.denunciante.ndenuncianteIdtipden == 3) {

          numCasoPlant = 1;

          nombreArchPlant = this.strDscNombrPlantillaAPJ;
          nombreArchPlantGen = this.strDscNomArchivoGenAPJ;

        }

        if (numCasoPlant == 1) {

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FLAG_DEN_REP_LEGAL');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.cdenuncianteFlgreprelegal);

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'EMPRE_RAZSOC');

          // console.log("===numIndex",numIndex);

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';
            // console.log("===numIndex1111");

            if (vFur.denunciante.personaComplemento) {

              // console.log("===numIndex222");

              if (vFur.denunciante.personaComplemento.cpersonaRazonsocial) {

                this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaRazonsocial;


              }



            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'EMPRE_RUC');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              if (vFur.denunciante.personaComplemento.cpersonaNrodoc) {

                this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaNrodoc;

              }

            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'EMPRE_DEPART');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              // this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaCdepartdomic;
              // this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.;

              if (vFur.denunciante.personaComplemento.personaDepartdomic) {

                this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.personaDepartdomic.cdptDpto);

              }



            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'EMPRE_PROV');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              // this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaCprovdomic;

              if (vFur.denunciante.personaComplemento.personaProvdomic) {

                this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.personaProvdomic.cprvProv);


              }


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'EMPRE_DIST');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              if (vFur.denunciante.personaComplemento.personaDistrdomic) {

                this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.personaDistrdomic.cdstDistrit);

              }

              // this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaCdistdomic;


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'EMPRE_DIRECC');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.cpersonaDscdireccion);

            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'EMPRE_REF');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              if (vFur.denunciante.personaComplemento.cpersonaDscreferencia) {

                this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.cpersonaDscreferencia);

              } else {

                this.pdDatos[numIndex].valor = '';

              }



            }

          }


        } else if (numCasoPlant == 2) {

          // nombreArchPlant = this.strDscNombrPlantillaEnt;
          // nombreArchPlantGen = this.strDscNomArchivoGenEnt;



          numIndex = this.pdDatos.findIndex(x => x.nombre == 'ENT_PUB_DENUNCIANTE');

          if (numIndex >= 0) {

            if (vFur.denunciante.entidadCompl) {

              this.pdDatos[numIndex].valor = vFur.denunciante.entidadCompl.centNombre;

            } else {

              this.pdDatos[numIndex].valor = '';

            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'ENT_PUB_DEP_DCIANTE');

          if (numIndex >= 0) {

            if (vFur.denunciante.departamentoCompl) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.departamentoCompl.cdptDpto);

            } else {

              this.pdDatos[numIndex].valor = '';

            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'ENT_PUB_PROV_DCIANTE');

          if (numIndex >= 0) {

            if (vFur.denunciante.provinciaCompl) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.provinciaCompl.cprvProv);

            } else {

              this.pdDatos[numIndex].valor = '';

            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'ENT_PUB_DIS_DCIANTE');

          if (numIndex >= 0) {

            if (vFur.denunciante.distritoCompl) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.distritoCompl.cdstDistrit);

            } else {

              this.pdDatos[numIndex].valor = '';

            }



          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'ENT_PUB_DIR_DCIANTE');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.cdenuncianteDscdireccent);

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'ENT_PUB_REF_DCIANTE');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.cdenuncianteDscrefcent);

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'MOD_PRESENTACION');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = (vFur.denunciante.cdenuncianteCodmodopresent == 'TR' ? 'Traslado de Denuncia' : 'Propio');

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_TIP_DOCIDENT');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              if (vFur.denunciante.personaComplemento.tipoDocumento) {

                this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.tipoDocumento.ctipdocumentoDsc;

              }

            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_NRO_DOCIDENT');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              if (vFur.denunciante.personaComplemento.cpersonaNrodoc) {

                this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaNrodoc;

              }




            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_NOMBRE');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.cpersonaNombres);


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_APE_PATER');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.cpersonaApepaterno);


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_APE_MATER');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.cpersonaApematerno);


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_DIRECCION');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.personaComplemento.cpersonaDscdireccion);


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_TELEFONO');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              if (vFur.denunciante.personaComplemento.cpersonaDsctelef) {

                this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaDsctelef;

              }




            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_MAIL');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              if (vFur.denunciante.personaComplemento.cpersonaDsccorreo) {

                this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaDsccorreo;

              }




            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'FUNCPUB_MOVIL');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.personaComplemento) {

              if (vFur.denunciante.personaComplemento.cpersonaDscmovil) {

                this.pdDatos[numIndex].valor = vFur.denunciante.personaComplemento.cpersonaDscmovil;

              }




            }

          }

          //////// CIUDADANO

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'TIP_DOCIDENTCIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              if (vFur.denunciante.persona.tipoDocumento) {

                this.pdDatos[numIndex].valor = vFur.denunciante.persona.tipoDocumento.ctipdocumentoDsc;

              }

            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'NRO_DOCIDENTCIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              this.pdDatos[numIndex].valor = vFur.denunciante.persona.cpersonaNrodoc;


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'NOM_DENUNCIANTECIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.persona.cpersonaNombres);


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'APE_PATERCIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.persona.cpersonaApepaterno);


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'APE_MATERCIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.persona.cpersonaApematerno);


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'DIRE_DENUNCIANTECIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              this.pdDatos[numIndex].valor = letraCapital(vFur.denunciante.persona.cpersonaDscdireccion);


            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'TELF_DENUNCIANTECIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              if (vFur.denunciante.persona.cpersonaDsctelef) {

                this.pdDatos[numIndex].valor = vFur.denunciante.persona.cpersonaDsctelef;

              }




            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'MAIL_DENUNCIANTECIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              if (vFur.denunciante.persona.cpersonaDsccorreo) {

                this.pdDatos[numIndex].valor = vFur.denunciante.persona.cpersonaDsccorreo;

              }




            }

          }

          numIndex = this.pdDatos.findIndex(x => x.nombre == 'MOV_DENUNCIANTECIU');

          if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = '';

            if (vFur.denunciante.persona) {

              if (vFur.denunciante.persona.cpersonaDscmovil) {

                this.pdDatos[numIndex].valor = vFur.denunciante.persona.cpersonaDscmovil;

              }




            }

          }


        }

      } else {

        numIndex = this.pdDatos.findIndex(x => x.nombre == 'TIP_DENUNCIANTE');

        if (numIndex >= 0) {

            this.pdDatos[numIndex].valor = DscDenuncAnonimo;

          }

      }

      if (this.denunciaContenedorC) {

        if (this.denunciaContenedorC.pruebaHechoC) {

          if (this.denunciaContenedorC.pruebaHechoC.evidenciaC) {

            vFur.listaDocumentoAdjuntoDet = this.denunciaContenedorC.pruebaHechoC.evidenciaC.listEvidencias;


          }

        }





      }




      vPlantillaDocumento.rutaArchivoPlantilla = this.strDscRutaArchivoPlant;
      vPlantillaDocumento.nombreArchivoPlantilla = nombreArchPlant;
      vPlantillaDocumento.nombreArchivoGenerado = nombreArchPlantGen;
      vPlantillaDocumento.rutaArchivoGenerado = this.strDscRutaArchivoGen;

      vPlantillaDocumento.datos = this.pdDatos;
      vPlantillaDocumento.tipoDocumento = CodTipDocPDF;
      vPlantillaDocumento.grillas = this._generarGrillasPlantillaDoc(vFur);

      this.spinner.show();

      this.externosService.generarDocumento(vPlantillaDocumento).subscribe(
        data => {

          // console.log("===========data Generar Documento");
          // console.log(data);

          // this.spinner.hide();

          if (flgProcLF) {



            vListDocumentoDet[0] = new DocumentoDet();
            vListDocumentoDet[0].cdocumentoCodtipo = CodTipoFichaFUR;
            vListDocumentoDet[0].cdocumentoCodsubtipo = CodSubTipoFichaOFI;

            // console.log("======codborrador");
            // console.log(strCodBorrador);
            // console.log("Gestión_de_Canales_"+ strCodBorrador + ".pdf");


            vListDocumentoDet[0].cdocumentoDscnombre = DscNomDoc + strCodBorrador + '.pdf'; // DscNombreFileOficioFUR;
            // vListDocumentoDet[0].cdocumentoDscnombre = DscNombreFileOficioFUR;
            // vListDocumentoDet[0].cdocumentoDscurl = data.rutaArchivo;
            vListDocumentoDet[0].strDdocumentoFchreg = GetDateTime(0, 0);
            vListDocumentoDet[0].ndocumentoIdtipd = vFur.nfurId;
            vListDocumentoDet[0].fileBase64 = data.base64;
            // vListDocumentoDet[0].ndocumentoIdtipdoc = 827; // INFORMACIÓN RECIBIDaA

            flgEvidencia = this.denunciaContenedorC.pruebaHechoC.cuenta_pruebas;

            this.denunciaContenedorC.pruebaHechoC.setCuenta_pruebas(true);

            // console.log("===========dataBase64");
            // console.log(data)
            this.spinner.hide();


          } else {

            vGeneralReturn.dscCampo1 = data.base64;
            vGeneralReturn.flgCampo1 = true;

            observer.next(vGeneralReturn);

          }


        },
        err => {

          this.spinner.hide();

          console.log(err);

        });

    });

    return plantillaObservable;

  }

  mostrarDatosGen(param: boolean) {

    // console.log("=====mostrarDatosGen",param);
    this.flgViewDatosGen  = param;
  }

  setFlgEnviarDenuncia(flag: boolean) {
    this.flgEnviarDenuncia = flag;
  }

  setFlgGuardarBorrador(flag: boolean) {
    this.flgGuardarBorrador = flag;
  }

  verFormularioWeb(data: Fur, flgLectura: boolean) {

    // let vFlgAnonimo:boolean = false;

    // let boolFlgLectura:boolean = flgLectura;

    setTimeout(() => {

      this.spinner.show();

      this.flgTransicionTab = false;

      if (this.flgViewDatosGen) {this.datosGeneralC.setDatosGenerales(data); }

      if (flgLectura) {

        this.denunciaContenedorC.entidadHechoC.entidadComponentReadEnable();
        this.denunciaContenedorC.hechoIrregularC.hechoIrregularCReadEnable();
        this.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.funcionarioCReadEnable();
        this.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.empresaCReadEnable();
        this.denunciaContenedorC.denunciaContenedorCReadEnable();
        this.denunciaContenedorC.pruebaHechoC.pruebaHechoCReadEnable();
        this.denunciaContenedorC.denunciaContenedorCReadEnable();
        this.denunciaContenedorC.instanciaC.instanciaCReadEnable();

      }


      // console.log("============setEntidadHecho");

      this.denunciaContenedorC.entidadHechoC.setEntidadHecho(data);

      // console.log("============setHechoIrregularComponent");

      this.denunciaContenedorC.hechoIrregularC.setHechoIrregularComponent(data);
      // this.hojaEvaluacionCmp.formularioCmp.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.setFuncionarioComponent(data);

      // console.log("============setEmpresaComponent");

      this.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.setEmpresaComponent(data);

      // console.log("============setPruebaHechoComponent");

      this.denunciaContenedorC.pruebaHechoC.setPruebaHechoComponent(data);

      // console.log("============setDenunciaContenedorC");

      this.denunciaContenedorC.setDenunciaContenedorC(data);

      // console.log("============setInstanciaC");

      this.denunciaContenedorC.instanciaC.setInstanciaC(data);

      // console.log("====boolFlgVerTabInfoCompl",boolFlgVerTabInfoCompl);

      // this._hablitarTabInfoCompl((boolFlgVerTabInfoCompl == true ? 1 : 2));
      this._hablitarTabAdicionales((flgLectura == true ? 1 : 2), data);

      // setTimeout(() => {

      //   this.BandejaNotifC.setFurBandeja(data);

      // }, 0);

      // setTimeout(() => {

      //   this.DatosMovilC.setFurRecupDatosMovil(data);

      // }, 0);

      // setTimeout(() => {

      //   this.InfoComplementariaWebC.setFurInfoCompl(data);

      // }, 0);

      // if cus 04
      if (!this.flgEsFud) {

        setTimeout(() => {

          // console.log("============this.contenedorDenuncianteC");

          if (this.contenedorDenuncianteC != null) {


            this.contenedorDenuncianteC.setContenedorDenuncianteC(data);

            if (flgLectura) {this.contenedorDenuncianteC.contenedorDenuncianteReadEnable(); }


          }

          setTimeout(() => {

            // console.log("============this.contenedorMpC");

            if (this.contenedorMpC != null) {

              if (flgLectura) {this.contenedorMpC.medidaProteccionCReadEnable(); }
              this.contenedorMpC.setMedidaProteccionC(data);

            }



          }, 0);

        }, 0);
      }

      this.spinner.hide();

    }, 0);

  }

  _hablitarTabInfoCompl(numCaso: number) {

    switch (numCaso) {
      case 1:

        this.flgTabInfCompl = true;

        break;
      case 2:

        this.flgTabInfCompl = false;

        break;

      default:
        break;
    }

  }

  _hablitarTabAdicionales(numCaso: number, furRecup: Fur) {

    let boolFlgTabAdic = false;

    switch (numCaso) {
      case 1:

        boolFlgTabAdic = true;

        break;
      case 2:

        boolFlgTabAdic = false;


        break;

      default:
        break;
    }

    this.flgTabMovil = boolFlgTabAdic;
    this.flgTabBandeja = boolFlgTabAdic;

    if (boolFlgTabAdic == true) {

      setTimeout(() => {

        this.BandejaNotifC.setFurBandeja(furRecup);

      }, 0);

      setTimeout(() => {

        this.DatosMovilC.setFurRecupDatosMovil(furRecup);

      }, 0);

    }

  }


  validarTab(valor: General) {

    let vFlgEncuestaDesact = false;
    const vFlgReqIden = valor.flgCampo1;
    const vFlgSeteo = valor.flgCampo2;
    const vFlgRecupBorrador = valor.flgCampo3;
    const vFlgCheckRIManual = valor.flgCampo4;
    const flgExisteDenunciante: boolean = valor.flgCampo5;

    this.flgTransicionTab = (vFlgCheckRIManual ? true : this.flgTransicionTab); // ACTIVACION MANUAL DEL CHECK REQ IDENT
    this.flgRecupBorrador = vFlgRecupBorrador; // PARA EVITAR EL SETEO POR DEFECTO DEL TIPO DE DENUNCIANTE

    if (vFlgSeteo) { // VIENE DE UN SETEO

        if (vFlgReqIden) {

          this._activarTabDenunciante(true);


        } else { // ENCUESTA


          if (vFlgRecupBorrador && flgExisteDenunciante) {

            this._activaEncuesta(true, vFlgSeteo);

          }

        }

    } else {

      if (this.flgActivaEncuesta) {

        this.contenedorDenuncianteC.setFlgAnonimo(false); // pRA MOSTRAR LA SECCION DE LA ENCUESTA EN EL TAB

        this.flgActivaEncuesta = false;

        vFlgEncuestaDesact = true;

      }

      this._activarTabDenunciante(vFlgReqIden);

      if (vFlgEncuestaDesact) {

        setTimeout(() => {

          this.contenedorDenuncianteC.iniciarDatosDefecto();

        }, 1);

      }

    }

  }

  _activarTabInfoCompl(valor: boolean) {


  }

  _activarTabDenunciante(valor: boolean) {

    let generalMDPB: General;

    this.tabDenunciante = valor;

    if (valor) {

      if (this.flgTransicionTab) {

        setTimeout(() => {

          // document.getElementById('aTabDenun').click();
          this._SelectTabDenunciante();
          // CUS04
          if (this.denunciaContenedorC.flgEsFur) {
            this.contenedorMpC.flgEsFur = true;
          }
        }, 1);

      }

    } else {

      generalMDPB = new General();

      generalMDPB.flgCampo1 = false;
      generalMDPB.flgCampo2 = true;

      this.ActivaPanelMP(generalMDPB);

    }

  }

  _activaEncuesta(flag: boolean, flgSeteo: boolean) {

    this.flgActivaEncuesta = flag;
    this.flgTransicionTab = !flgSeteo; // SI ES SETEO NO APLICA TRANSICION

    // this.tabDenunciante = flag;

    this._activarTabDenunciante(flag);


  }

  ActivaPanelMP(data: General) {

    const vFlgSolicMPB = data.flgCampo1;
    const vFlgCambManual = data.flgCampo2;
    let vFlgCambManualMDPB: boolean = data.flgCampo3;

    vFlgCambManualMDPB = (vFlgCambManualMDPB ? vFlgCambManualMDPB : false);

    this.tabProteccion = vFlgSolicMPB; // flgSolicitaMPB;

    if (vFlgCambManual) {

      this.flgTransicionTab = true;

    }

    if (vFlgSolicMPB) {

      if (this.flgTransicionTab) {

        setTimeout(() => {

          document.getElementById('aTabMP').click();
        // CUS04
          if (this.contenedorDenuncianteC.flgEsFur) {
          this.contenedorMpC.flgEsFur = true;
        }

          this.contenedorMpC.setFlgAcepto(true);

        }, 1);



      }

      // setTimeout(() => {

      // this.contenedorMpC.CambioAcepto(true);

      // }, 1);

    }

    if (vFlgCambManualMDPB == true) {

      setTimeout(() => {

        document.getElementById('aTabDenun').click();
        this.contenedorDenuncianteC.flgSolicMP = false;

      }, 1);

    }

  }

  _validaDatosPersonaN(persona: Persona, numCaso: number) {

    let numIdMedioNotif: number = null;

    if (persona.npersonaIdtipdoc == 0 || persona.npersonaIdtipdoc == null) {

      openModalMensaje('Formulario Virtual', 'Debe seleccionar el tipo de denunciante, por favor verifique.', this.dialog);
      return false;

    }

    // console.log("===========0persona.cpersonaNrodoc");
    // console.log(persona.cpersonaNrodoc);

    if (persona.cpersonaNrodoc == '' || persona.cpersonaNrodoc == null) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar el número de documento, por favor verifique.', this.dialog);
      return false;

    }

    // JCMF quitando validacion de nombres
    /**
    if (persona.cpersonaNombres == '' || persona.cpersonaNombres == null) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar el nombre de la persona, por favor verifique.', this.dialog);
      return false;

    }

    if (persona.cpersonaApepaterno == '' || persona.cpersonaApepaterno == null) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar el apellido paterno de la persona, por favor verifique.', this.dialog);
      return false;

    }

    if (persona.cpersonaApematerno == '' || persona.cpersonaApematerno == null) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar el apellido materno de la persona, por favor verifique.', this.dialog);
      return false;

    }*/

    if (persona.cpersonaDscdireccion == '' || persona.cpersonaDscdireccion == null) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar la dirección de la persona, por favor verifique.', this.dialog);
      return false;

    }

    // if(persona.cpersonaDsctelef == "" || persona.cpersonaDsctelef == null)
    // {

    //   openModalMensaje("Formulario Virtual","Debe ingresar el teléfono de la persona, por favor verifique.",this.dialog);
    //   return false;

    // }

    // console.log("====persona.cpersonaDsccorreo ",persona.cpersonaDsccorreo );

    if (persona.cpersonaDsccorreo == '' || persona.cpersonaDsccorreo == null) {

      if (numCaso == 1) {

        numIdMedioNotif = this.contenedorDenuncianteC.idMedioNotif;

        // console.log("====numIdMedioNotif ",numIdMedioNotif);

        if (numIdMedioNotif == NumIdMedioNotifEmail) {

          openModalMensaje('Formulario Virtual', 'Debe ingresar el correo, por favor verifique.', this.dialog);
          return false;

        }

      }


    } else {

      if (!ValidarEmail(persona.cpersonaDsccorreo)) {

        openModalMensaje('Formulario Virtual', 'El correo ingresado no es válido, por favor verifique.', this.dialog);
        return false;

      }

    }



    // if(persona.cpersonaDscmovil == "" || persona.cpersonaDscmovil == null)
    // {

    //   openModalMensaje("Formulario Virtual","Debe ingresar el móvil de la persona, por favor verifique.",this.dialog);
    //   return false;

    // }

    return true;

  }

validarGuardar(): boolean {
  const flgPruebas = this.denunciaContenedorC.pruebaHechoC.cuenta_pruebas;
  const vEntidadHechoC = this.denunciaContenedorC.entidadHechoC;
  const vHechoIrregular = this.denunciaContenedorC.hechoIrregularC;
  const cfurCodent = vEntidadHechoC.nombreEntidad;

  //console.log('validarGuardar');
  //console.log(vEntidadHechoC);
  // var cfurCdepent = vEntidadHechoC.cfurCdepent;
  // var cfurCdistent = vEntidadHechoC.cfurCdistent;
  // var cfurCprovent = vEntidadHechoC.cfurCprovent;
  // var cfurDscrefentidad = vEntidadHechoC.cfurDscrefentidad;
  // var cfurDirentidad = vEntidadHechoC.cfurDirentidad;
  // var nfurIdmacroproceso = vHechoIrregular.nfurIdmacroproceso; //vEntidadHechoC.nfurIdtipohecho;
  const flgObraPub = vEntidadHechoC.flgObrasPub;
  const listObraPub = vHechoIrregular.listObrasPublicas;
  // var entidadSelec = vEntidadHechoC.entidad;
  const cfurDschecho = vHechoIrregular.cfurDschecho;
  // var flgPerjuicioEco = ConvertirFlag(vHechoIrregular.perjuicio_economico);
  // var flgMontoDesc = ConvertirFlag(vHechoIrregular.flgMontoDesc);

  const strFechaIniPer: string = vHechoIrregular.strFechaIniPer;
  const strFechaFinPer: string = vHechoIrregular.strFechaFinPer;
  let fechaIniPer: Date = new Date(strFechaIniPer);
  let fechaFinPer: Date = new Date(strFechaFinPer);
  fechaFinPer.setDate(fechaFinPer.getDate() + 1);
  fechaIniPer.setDate(fechaIniPer.getDate() + 1);

  const flgConoceFun = this.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.conoce_funcionario;
  const listDenunciado = this.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.listDenunciado;
  const flgConoceEmpresa = this.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.flgConoceEmpresa;
  const listEmpresa = this.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.empresaList;
  const flgHechoContOcu: boolean = this.denunciaContenedorC.hechoIrregularC.ocurre_hecho;
  const flgPrecisa: boolean = this.denunciaContenedorC.hechoIrregularC.precisa_hecho;
  const otra_instancia = this.denunciaContenedorC.instanciaC.otra_instancia;
  const instanciaList = this.denunciaContenedorC.instanciaC.instanciaList;
  let archivosAlfresco = [];
  let listEvidencias = [];
  let nfurIdtipdenun = null;
  let formContenedorDenunciante = null;
  let flgAgrupacion = null;
  const dscAgrupacion = null;
  let flgPersonaNatural = null;
   // PESTAÑA DENUNCIANTE
  formContenedorDenunciante = this.contenedorDenuncianteC;
  let personaNaturalC: PersonaNaturalComponent = null;
  const formPersonaNatural = null;
  let flgPersonaJuridica = null;
  let dscValidaSunat = null;
  let flgRepreLegalPJ = false;
  let flgSolicMP = null;
  let flgAceptoMP = null;
  let flgConfirmaSolMP = null;
  let vIdRangoEdad = null;
  let vCodSexo = null;
  let vDscEnteroH = null;
  const vDenuncianteAnonimo = null;
  let nroDocRuc = null;
  let vFlgMostrarCongresista = null;
  let vDenunciante: Denunciante = null;
  let vFlgValidaPersNat = true;
  let vFlgMostrarEntidad = false;
  let dscMensaje = '';

  let fechaActual = new Date();

  fechaFinPer = new Date(fechaFinPer.getFullYear(), fechaFinPer.getMonth(), fechaFinPer.getDate());
  fechaIniPer = new Date(fechaIniPer.getFullYear(), fechaIniPer.getMonth(), fechaIniPer.getDate());
  fechaActual = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), fechaActual.getDate());


  if (cfurCodent == '' || cfurCodent == null) {


      openModalMensaje('Formulario Virtual', 'Debe ingresar la entidad, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        this._SelectTabDenuncia();

      });



      return false;
  }

  if (listObraPub.length == 0 && flgObraPub) {

    openModalMensaje('Formulario Virtual', 'Debe seleccionar la obra pública y sus hechos irregulares, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        this._SelectTabDenuncia();

      });
    return   false;

  }

  if (cfurDschecho == '' || cfurDschecho == null) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar la descripción del hecho irregular, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        this._SelectTabDenuncia();

      });

      return false;
  }

  // console.log("====strFechaIniPer",strFechaIniPer);

  if(flgPrecisa){

    if (strFechaIniPer == null || isEmpty(strFechaIniPer)) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar correctamente la fecha inicial del hecho irregular, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        this._SelectTabDenuncia();

      });

      return false;

    }

    if (isEmpty(strFechaFinPer)) {

      openModalMensaje('Formulario Virtual', 'Debe ingresar la fecha final del hecho irregular, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        this._SelectTabDenuncia();

      });

      return false;

    }

    if (fechaIniPer > fechaFinPer) {

      openModalMensaje('Formulario Virtual', 'La fecha inicial del hecho irregular no debe ser mayor al final, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        this._SelectTabDenuncia();

      });
      return false;

    }

    if (fechaActual < fechaIniPer) {

      openModalMensaje('Formulario Virtual', 'La fecha inicial del hecho irregular no debe ser mayor al actual, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        this._SelectTabDenuncia();

      });
      return false;

    }


    if (fechaActual < fechaFinPer) {

      openModalMensaje('Formulario Virtual', 'La fecha final del hecho irregular no debe ser mayor al actual, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

        this._SelectTabDenuncia();

      });
      return false;

    }


    if (flgHechoContOcu) {

      // console.log("======fechas",fechaActual,fechaFinPer)

      if (ConvertDateTimeToStr(fechaActual) != ConvertDateTimeToStr(fechaFinPer)) {

        openModalMensaje('Formulario Virtual', 'La fecha final del hecho irregular debe ser el actual, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

          this._SelectTabDenuncia();

        });
        return false;

      }



    }
  }


  let strDesEvidencia = null;
  if (flgPruebas) {
   // listEvidencias = this.denunciaContenedorC.pruebaHechoC.evidenciaC.listEvidencias;
    strDesEvidencia = this.denunciaContenedorC.pruebaHechoC.strDesEvidencia;
    archivosAlfresco = this.denunciaContenedorC.pruebaHechoC.archivosAlfresco;
  }

if (flgPruebas ) {
  //&& (archivosAlfresco.length == 0 || strDesEvidencia == null || strDesEvidencia === undefined || strDesEvidencia.trim() === '')
  if (archivosAlfresco.length == 0 &&  (strDesEvidencia == null || strDesEvidencia === undefined || strDesEvidencia.trim() === '' )) {

    openModalMensaje('Formulario Virtual', 'Ud. Ha indicado que cuenta con pruebas; sin embargo no ha adjuntado archivo', this.dialog).afterClosed().subscribe(result => {

      this._SelectTabDenuncia();

    });
    return false;

  }
}

  if (flgConoceFun == true && listDenunciado.length == 0) {

    openModalMensaje('Formulario Virtual', 'Ud. Ha indicado que existe Funcionarios involucrados; sin embargo, no ha registrado ninguno', this.dialog).afterClosed().subscribe(result => {

      this._SelectTabDenuncia();

    });
    return false;

  }


  if (flgConoceEmpresa == true && listEmpresa.length == 0) {

    openModalMensaje('Formulario Virtual', 'Ud. Ha indicado que existe Empresas involucradas; sin embargo, no ha registrado ninguna', this.dialog).afterClosed().subscribe(result => {

      this._SelectTabDenuncia();

    });
    return false;

  }

  if (otra_instancia == true && instanciaList.length == 0) {

    openModalMensaje('Formulario Virtual', 'Ud. Ha indicado que el hecho ocurrió en otra(as) entidad(es); sin embargo, no ha registrado ninguna', this.dialog).afterClosed().subscribe(result => {

      this._SelectTabDenuncia();

    });
    return false;

  }

      // validaciones de denunciante
  const flgReqIdent = this.denunciaContenedorC.requireIdentificarse;

  if (flgReqIdent) {
        nfurIdtipdenun = formContenedorDenunciante.denunciante.ndenuncianteIdtipden;
        flgPersonaNatural = this.contenedorDenuncianteC.mostrarPersonaNatural;
        flgPersonaJuridica = this.contenedorDenuncianteC.mostrarPersonaJuridica;
        flgAgrupacion = this.contenedorDenuncianteC.mostrarAgrupacion;
        vFlgMostrarCongresista = this.contenedorDenuncianteC.flgMostrarCongresista;
        vFlgMostrarEntidad = this.contenedorDenuncianteC.flgMostrarEntidad;

        vIdRangoEdad = this.contenedorDenuncianteC.denunciante.ndenuncianteIdrangoedad;
        vCodSexo = this.contenedorDenuncianteC.denunciante.cdenuncianteCodsexo;
        vDscEnteroH = this.contenedorDenuncianteC.denunciante.cdenuncianteDscenterohecho;


        if (nfurIdtipdenun == 0 || nfurIdtipdenun == null) {

          openModalMensaje('Formulario Virtual', 'Debe seleccionar el tipo de denunciante, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

            this._SelectTabDenunciante();

          });
          return false;

        }

        if (vIdRangoEdad == 0 || vIdRangoEdad == null) {

          openModalMensaje('Formulario Virtual', 'Debe seleccionar el rango de edad del denunciante, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

            this._SelectTabDenunciante();

          });
          return false;

        }

        if (vCodSexo == '' || vCodSexo == null) {

          openModalMensaje('Formulario Virtual', 'Debe seleccionar el sexo del denunciante, por favor verifique.', this.dialog);
          return false;

        }

        if (vDscEnteroH == '' || vDscEnteroH == null) {

          openModalMensaje('Formulario Virtual', 'Debe completar el campo ¿Cómo se enteró del hecho irregular?; Por favor verifique.', this.dialog).afterClosed().subscribe(result => {

            this._SelectTabDenunciante();

          });
          return false;

        }


        if (flgPersonaNatural || flgAgrupacion || flgPersonaJuridica || vFlgMostrarCongresista || vFlgMostrarEntidad) {


          if (flgPersonaNatural) {

            personaNaturalC = this.contenedorDenuncianteC.personaNaturalComponent;
            // formPersonaNatural = personaNaturalC.formPersonaNatural.controls;
            // Revisar: GSOLIS


          } else if (flgAgrupacion) {
            personaNaturalC = this.contenedorDenuncianteC.agrupacionComponent.personaNaturalComponent;



            vDenunciante = this.contenedorDenuncianteC.agrupacionComponent.getDatosAgrupacion();

            this.personaCompl = vDenunciante.personaComplemento;

            nroDocRuc = this.personaCompl.cpersonaNrodoc;

            // this.personaCompl = this.contenedorDenuncianteC.personaJuridicaComponent.persona;
            flgRepreLegalPJ =  this.contenedorDenuncianteC.agrupacionComponent.flgRepreLegal;

            dscValidaSunat = nroDocRuc; // formPersonaJuridica.input_validasunat.value;

            if (vDenunciante.cdenuncianteFlgsinruc == 'SI') {

              if (isEmpty(vDenunciante.cdenuncianteDscagrup)) {

                openModalMensaje('Formulario Virtual', 'Debe ingresar la empresa o agrupación, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

                  this._SelectTabDenunciante();

                });
                return;

              }

            } else {

              if (isEmpty(dscValidaSunat)) {

                openModalMensaje('Formulario Virtual', 'Debe ingresar la empresa o agrupación, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

                  this._SelectTabDenunciante();

                });
                return;

              }

            }



          } else if (flgPersonaJuridica) {

            personaNaturalC = this.contenedorDenuncianteC.personaJuridicaComponent.personaNaturalC;

            // let nroDocRuc = this.contenedorDenuncianteC.personaJuridicaComponent.persona.cpersonaNrodoc;
            // persna juridica

            vDenunciante = this.contenedorDenuncianteC.personaJuridicaComponent.getDatosEmpresa();
            // (vListDenuncXRL = vDenunciante.listaDenunciantePorReplegal;

            this.personaCompl = vDenunciante.personaComplemento;

            nroDocRuc = this.personaCompl.cpersonaNrodoc;



            // this.personaCompl = this.contenedorDenuncianteC.personaJuridicaComponent.persona;
            flgRepreLegalPJ =  this.contenedorDenuncianteC.personaJuridicaComponent.flgRepreLegal;

            dscValidaSunat = nroDocRuc; // formPersonaJuridica.input_validasunat.value;

            if (vDenunciante.cdenuncianteFlgsinruc == 'SI') {

              if (isEmpty(vDenunciante.cdenuncianteDscagrup)) {

                openModalMensaje('Formulario Virtual', 'Debe ingresar la empresa, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

                  this._SelectTabDenunciante();

                });
                return;

              }

            } else {


              if (dscValidaSunat == '' || dscValidaSunat == null) {

                openModalMensaje('Formulario Virtual', 'Debe ingresar la empresa o agrupación, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

                  this._SelectTabDenunciante();

                });
                return;

              }

            }

          } else if (vFlgMostrarCongresista) {

            vDenunciante = this.contenedorDenuncianteC.denuncianteCongresistaC.getDenunCongresista();
            personaNaturalC = this.contenedorDenuncianteC.denuncianteCongresistaC.getDcPersComponent();

            this.persona = vDenunciante.persona;
            this.personaCompl = vDenunciante.personaComplemento;

            if (this.personaCompl != null) {

              vFlgValidaPersNat = this._validaDatosPersonaN(this.personaCompl, 2);

              if (!vFlgValidaPersNat) {

                return false;

              }

            }

          } else if (vFlgMostrarEntidad) {

            vDenunciante = this.contenedorDenuncianteC.dcianteEntidadPubC.getDenunEntidadPub();
            personaNaturalC = this.contenedorDenuncianteC.dcianteEntidadPubC.getDcPersComponent();

            this.persona = vDenunciante.persona;
            this.personaCompl = vDenunciante.personaComplemento;

            if (isEmpty(vDenunciante.cdenuncianteCodentcompl)) {

              openModalMensaje('Formulario Virtual', 'Debe ingresar la entidad, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

                this._SelectTabDenunciante();

              });
              return;

            }

            if (this.personaCompl != null) {

              vFlgValidaPersNat = this._validaDatosPersonaN(this.personaCompl, 2);

              if (!vFlgValidaPersNat) {

                return false;

              }

            }

          }

          vFlgValidaPersNat = true;

          this.persona = personaNaturalC.persona;

          // console.log("==============0this.persona");
          // console.log(this.persona);

          vFlgValidaPersNat = this._validaDatosPersonaN(this.persona, 1);

          // console.log("==============vFlgValidaPersNat");
          // console.log(vFlgValidaPersNat);

          if (!vFlgValidaPersNat) {

            return false;

          }

        }


        flgSolicMP = this.contenedorDenuncianteC.flgSolicMP;
        if (flgSolicMP) {

           // MP
          flgAceptoMP = this.contenedorMpC.flgAcepto;
          flgConfirmaSolMP = this.contenedorMpC.flgSolicita;

          if (!flgAceptoMP) {

            openModalMensaje('Formulario Virtual', 'Debe aceptar lo establecido en medidas de protección, por favor verifique.', this.dialog).afterClosed().subscribe(result => {

              this._SelectTabMDP();

            });
            return false;

          }



        }
      } else {

        // vDenuncianteAnonimo =  this.denunciaContenedorC.denuncianteAnonimo;

        if (!this.flgActivaEncuesta) {



          // openModalMensaje("Formulario Virtual","Estimado por favor apoyenos completando la siguiente ENCUESTA",this.dialog);

          // const dialogRef = openModalMensaje("Formulario Virtual","Estimado, si ustd. no se identifica su denuncia se tratará como anónima, por favor apóyenos completando la siguiente ENCUESTA.",this.dialog);

          if (flgReqIdent) {

            dscMensaje = 'Estimado, por favor apóyenos completando la siguiente ENCUESTA.';

          } else {


            dscMensaje = 'Se registrará la denuncia como anónima, por favor marque los siguientes datos.';


          }

          const dialogRef = openModalMensaje('Formulario Virtual', dscMensaje, this.dialog);

          dialogRef.afterClosed().subscribe(result => {
            this._activaEncuesta(true, false);
          });

          // this._activaEncuesta(true);

          return false;

        }

      }

  return true;

}


setFurFw(furFw: Fur) {

  this.fur = furFw;

}

/*
GSOLIS: SI IDFURBASE NO EXISTE = 0 */
Guardar(idFurBase: number, usuarioSup: string, usuarioAsig: string, estadoFurEval: number) {

  // this.strDscMensajeSpinner = DscMensajeSpinner2;
  this._CambiarTextoSpinner(2);

  this.spinner.show();

  const vFlgFw = (idFurBase == 0 ? true : false);
  // var vCodFur = "";
  const vFurNew = null;
  let vFlgNuevoFw = false;

  if (this.fur == null) {
    this.fur = new Fur();
    vFlgNuevoFw = true;

  }
  this.persona = new Persona();
  this.personaCompl = new Persona();

  const nroDocRuc = null;

  let vDenuncianteCompl: Denunciante = null;
  // var vDscRefDomicCompl:string = null;

  const vFchVencimiento: Date = null;

  let flgAceptoMP = null;
  let flgConfirmaSolMP = null;
  let formPersonaNatural = null;
  let formContenedorDenunciante = null;
  // var formPersonaJuridica  = null;
  const formAgrupacion  = null;
  let nfurIdtipdenun = null;
  let vNumIdRangoEdad = null;
  let vCodSexo = null;
  let vFlgServPub = null;
  let vFlgTestigoH =  null;
  let vFlgAccDir = null;
  let vDscEnteroH = null;

  let flgPersonaNatural = null;
  let flgPersonaJuridica = null;
  let flgAgrupacion = null;
  let vFlgCongresista = null;
  let flgNotificacion = null;
  let flgTrabEntDenun = null;
  let flgTrabfam = null;
  let flgSolicMP = null;
  const dscValidaSunat = null;
  const dscAgrupacion = null;
  let cantTotalReg = 0;
  let personaNaturalC: PersonaNaturalComponent = null;
  let vIdMedioNotif = null;
  const dscNomAgrup = null;
  let flgRepreLegalPJ = false;
  const idFur = null;
  let vDenuncianteAnonimo = null;


  const vEntidadHechoC = this.denunciaContenedorC.entidadHechoC;

  const vHechoIrregular = this.denunciaContenedorC.hechoIrregularC;

  const flgObraPub = vEntidadHechoC.flgObrasPub;

  const listObraPub = vHechoIrregular.listObrasPublicas;
  const listContratacion = vHechoIrregular.listContratacion;
  const entidadSelec = vEntidadHechoC.entidad;

  const cfurCodent = vEntidadHechoC.cfurCodent;
  const cfurCdepent = vEntidadHechoC.cfurCdepent;
  const cfurCdistent = vEntidadHechoC.cfurCdistent;
  const cfurCprovent = vEntidadHechoC.cfurCprovent;

  this.fur.cfurDepartamento = vEntidadHechoC.cfurDepartamento;
  this.fur.cfurProvincia = vEntidadHechoC.cfurProvincia;
  this.fur.cfurDistrito = vEntidadHechoC.cfurDistrito;



  const cfurDscrefentidad = vEntidadHechoC.cfurDscrefentidad;
  const nombreEntidad = vEntidadHechoC.nombreEntidad;
  const cfurDirentidad = vEntidadHechoC.cfurDirentidad;

  const nfurIdmacroproceso = vHechoIrregular.nfurIdmacroproceso; // vEntidadHechoC.nfurIdtipohecho;
  this.fur.cfurTipoHecho = vHechoIrregular.cfurTipoHecho;

  const boolFlgExisteOP: boolean = vHechoIrregular.getFlgExisteOP();


  const cfurDschecho = vHechoIrregular.cfurDschecho;

  const flgPerjuicioEco = ConvertirFlag(vHechoIrregular.perjuicio_economico);
  const flgMontoDesc = ConvertirFlag(vHechoIrregular.flgMontoDesc);


  const flgHechoContOcu = this.denunciaContenedorC.hechoIrregularC.ocurre_hecho;
  const flgHechoprecisa = this.denunciaContenedorC.hechoIrregularC.precisa_hecho;

  const nfurImpmontoperj = this.denunciaContenedorC.hechoIrregularC.nfurImpmontoperj;

  const strFechaIniPer = ConvertStrDateToFormatBD(vHechoIrregular.strFechaIniPer);
  const strFechaFinPer = ConvertStrDateToFormatBD(vHechoIrregular.strFechaFinPer);

  const flgConoceFun = this.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.conoce_funcionario;
  const listDenunciado = this.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.listDenunciado;
  const listEmpresa = this.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.empresaList;

  const flgPruebas = this.denunciaContenedorC.pruebaHechoC.cuenta_pruebas;
  let listEvidencias = [];
  let estadoFormulario = null;
  let fechaHoraString = null;
  let vDenunciante: Denunciante = null;
  let vCodModoPresent = null;
  let vListDenuncXRL: DenuncianteXRepLegal[] = null;
  let vFlgEntidad = false;
  let vCodDistEnt: string = null;
  let vCodProvEnt: string = null;
  let vCodDepartEnt: string = null;
  let vCodDireccEnt: string = null;
  let vCodReferenEnt: string = null;
  let vCodEntidadCompl: string = null;
  const vDscOtrosCompl: string = null;
  let flgAutorizoActo = false;
  let flgAutorizoEmail = false;
  let strDesEvidencia: string = null;
  let archivosAlfresco = [];
  if (flgPruebas) {
    //listEvidencias = this.denunciaContenedorC.pruebaHechoC.evidenciaC.listEvidencias;
    strDesEvidencia = this.denunciaContenedorC.pruebaHechoC.strDesEvidencia;
    archivosAlfresco = this.denunciaContenedorC.pruebaHechoC.archivosAlfresco;
  }
 // listFilesEvidencias;//this.denunciaContenedorC.pruebaHechoC.listEvidencias;

  const flgReqIdent = this.denunciaContenedorC.requireIdentificarse;

  const instanciaC = this.denunciaContenedorC.instanciaC; // pruebaHechoC.instanciaC;
  const flgOtrInst = instanciaC.getFlgOtraInstancia();
  let numIdInstanciaExt: number = null;



  if (this.flgEnviarDenuncia) {

    estadoFormulario = NumIdEstadoRegistrado;

    if (this.generalParams) {numIdInstanciaExt = this.generalParams.numCampo1; }

    if (!vFlgNuevoFw) {

      this.fur.booleanCodborrador = false;

    }


  } else if (this.flgGuardarBorrador) {

    estadoFormulario = NumIdEstadoBorrador;

    if (!vFlgNuevoFw) {

      this.fur.booleanCodborrador = false;

    }

  } else {

    estadoFormulario = this.datosGeneralC.estado_formulario;

  }

  if (vFlgNuevoFw) {

    fechaHoraString = this.strFchHorInicioReg;

  } else {

    fechaHoraString = this.datosGeneralC.fecha_registro + ' ' + this.datosGeneralC.hora_inicio2;

  }


  if (flgReqIdent) {

    // console.log("===========guardar 2");

    flgPersonaNatural = this.contenedorDenuncianteC.mostrarPersonaNatural;
    flgPersonaJuridica = this.contenedorDenuncianteC.mostrarPersonaJuridica;
    flgAgrupacion = this.contenedorDenuncianteC.mostrarAgrupacion;
    vFlgCongresista = this.contenedorDenuncianteC.flgMostrarCongresista;
    vFlgEntidad = this.contenedorDenuncianteC.flgMostrarEntidad;
    // PESTAÑA DENUNCIANTE
    formContenedorDenunciante = this.contenedorDenuncianteC; // formContenedorDenunciante.controls;

    // PIE CONTENEDOR
    flgNotificacion = this.contenedorDenuncianteC.flgNotificacion;
    flgTrabEntDenun = this.contenedorDenuncianteC.flgTrabEntDenun;
    flgTrabfam = this.contenedorDenuncianteC.flgTrabfam;
    flgSolicMP = this.contenedorDenuncianteC.flgSolicMP;

    vIdMedioNotif = this.contenedorDenuncianteC.idMedioNotif;
    flgAutorizoActo = this.contenedorDenuncianteC.flgAutorizoActo;
    flgAutorizoEmail = this.contenedorDenuncianteC.flgAutorizoEmail;

    nfurIdtipdenun = formContenedorDenunciante.denunciante.ndenuncianteIdtipden;
    vNumIdRangoEdad = formContenedorDenunciante.denunciante.ndenuncianteIdrangoedad;
    vCodSexo = formContenedorDenunciante.denunciante.cdenuncianteCodsexo;
    vFlgServPub = formContenedorDenunciante.denunciante.cdenuncianteFlgservpub;
    vFlgTestigoH = formContenedorDenunciante.denunciante.cdenuncianteFlgtestigoh;
    vFlgAccDir = formContenedorDenunciante.denunciante.cdenuncianteFlgaccdirinf;
    vDscEnteroH = formContenedorDenunciante.denunciante.cdenuncianteDscenterohecho;


    if (vFlgCongresista) {

      vDenunciante = this.contenedorDenuncianteC.denuncianteCongresistaC.getDenunCongresista();

      this.persona = vDenunciante.persona;
      this.personaCompl = vDenunciante.personaComplemento;

      vCodModoPresent = vDenunciante.cdenuncianteCodmodopresent;


    }

    if (vFlgEntidad) {

      // vDenuncianteCompl = new Denunciante();

      vDenunciante = this.contenedorDenuncianteC.dcianteEntidadPubC.getDenunEntidadPub();

      // console.log("==========vDenunciante");
      // console.log(vDenunciante);

      this.persona = vDenunciante.persona;
      this.personaCompl = vDenunciante.personaComplemento;

      vCodModoPresent = vDenunciante.cdenuncianteCodmodopresent;
      // vDscOtrosCompl = vDenunciante.cdenuncianteDscotroscompl;

      vCodDepartEnt = vDenunciante.cdenuncianteCdeptent;
      vCodProvEnt = vDenunciante.cdenuncianteCprovent;
      vCodDistEnt = vDenunciante.cdenuncianteCdistent;
      vCodDireccEnt = vDenunciante.cdenuncianteDscdireccent;
      vCodReferenEnt = vDenunciante.cdenuncianteDscrefcent;

      vCodEntidadCompl = vDenunciante.cdenuncianteCodentcompl;

    }


    if (flgPersonaNatural || flgAgrupacion) {

      // console.log("===========guardar 4");

      if (flgPersonaNatural) {

        personaNaturalC = this.contenedorDenuncianteC.personaNaturalComponent;
        formPersonaNatural = personaNaturalC.formPersonaNatural.controls;
        // Revisar: GSOLIS
        this.persona.strDpersonaFemidoc = personaNaturalC.persona.strDpersonaFemidoc;

      } else if (flgAgrupacion) {
        personaNaturalC = this.contenedorDenuncianteC.agrupacionComponent.personaNaturalComponent;

        // console.log(personaNaturalC);

        formPersonaNatural = personaNaturalC.formPersonaNatural.controls;

        vDenuncianteCompl = this.contenedorDenuncianteC.agrupacionComponent.getDatosAgrupacion();

        this.personaCompl = vDenuncianteCompl.personaComplemento; // this.contenedorDenuncianteC.personaJuridicaComponent.persona;

        flgRepreLegalPJ =  this.contenedorDenuncianteC.agrupacionComponent.getFlgRepreLegal();
        vListDenuncXRL = vDenuncianteCompl.listaDenunciantePorReplegal;

      }

      // nGModel Persona
      this.persona = personaNaturalC.persona;

    }

    if (flgPersonaJuridica) {

      // this.persona = this.contenedorDenuncianteC.personaJuridicaComponent.persona;
      this.persona = this.contenedorDenuncianteC.personaJuridicaComponent.personaNaturalC.persona;

      vDenuncianteCompl = this.contenedorDenuncianteC.personaJuridicaComponent.getDatosEmpresa();

      this.personaCompl = vDenuncianteCompl.personaComplemento; // this.contenedorDenuncianteC.personaJuridicaComponent.persona;

      vListDenuncXRL = vDenuncianteCompl.listaDenunciantePorReplegal;

      flgRepreLegalPJ =  this.contenedorDenuncianteC.personaJuridicaComponent.flgRepreLegal;


    }


    if (this.fur.denunciante == null) {this.fur.denunciante = new Denunciante(); }

    if (this.fur.denunciante.persona == null) {this.fur.denunciante.persona = new Persona(); }

    // this.fur.denunciante.persona = this.persona;

    this.fur.denunciante.persona.cpersonaApematerno = this.persona.cpersonaApematerno;
    this.fur.denunciante.persona.cpersonaApepaterno = this.persona.cpersonaApepaterno;
    this.fur.denunciante.persona.cpersonaCdepartdomic = this.persona.cpersonaCdepartdomic;
    this.fur.denunciante.persona.cpersonaCdistdomic = this.persona.cpersonaCdistdomic;
    this.fur.denunciante.persona.cpersonaCprovdomic = this.persona.cpersonaCprovdomic;
    this.fur.denunciante.persona.cpersonaDscreferencia = this.persona.cpersonaDscreferencia;
    this.fur.denunciante.persona.cpersonaDsccorreo = this.persona.cpersonaDsccorreo;
    this.fur.denunciante.persona.cpersonaDscdireccion = this.persona.cpersonaDscdireccion;
    this.fur.denunciante.persona.cpersonaDscmovil = this.persona.cpersonaDscmovil;
    this.fur.denunciante.persona.cpersonaDscreprelegal = this.persona.cpersonaDscreprelegal;
    this.fur.denunciante.persona.cpersonaDsctelef = this.persona.cpersonaDsctelef;
    this.fur.denunciante.persona.cpersonaNombres = this.persona.cpersonaNombres;
    this.fur.denunciante.persona.cpersonaNrodoc = this.persona.cpersonaNrodoc;
    this.fur.denunciante.persona.cpersonaPrinommater = this.persona.cpersonaPrinommater;
    this.fur.denunciante.persona.cpersonaRazonsocial = this.persona.cpersonaRazonsocial;
    // this.fur.denunciante.persona.dpersonaFemidoc = this.persona.dpersonaFemidoc;
    this.fur.strDesEvidencia = strDesEvidencia;
    this.fur.archivosAlfresco = archivosAlfresco;
    this.fur.denunciante.persona.dpersonaFnacimiento = this.persona.dpersonaFnacimiento;
    this.fur.denunciante.persona.npersonaIdtipdoc = this.persona.npersonaIdtipdoc;
    this.fur.denunciante.persona.npersonaId = this.persona.npersonaId;
    this.fur.denunciante.persona.strDpersonaFemidoc = this.persona.strDpersonaFemidoc;
    this.fur.denunciante.persona.cpersonaCodsexo = this.persona.cpersonaCodsexo;
    // this.fur.denunciante.persona. = this.persona.npersonaIdtipdoc;

    this.fur.denunciante.persona.strDpersonaFnacimiento = this.persona.strDpersonaFnacimiento;



    this.fur.denunciante.cdenuncianteFlgmedidaprotec = ConvertirFlag(flgSolicMP);
    this.fur.denunciante.cdenuncianteFlgtrabentden = ConvertirFlag(flgTrabEntDenun);
    this.fur.denunciante.cdenuncianteFlgfamtrab = ConvertirFlag(flgTrabfam);
    this.fur.denunciante.cdenuncianteFlgnotelec = ConvertirFlag(flgNotificacion);


    this.fur.denunciante.cdenuncianteDscdirecc = this.persona.cpersonaDscdireccion;
    this.fur.denunciante.cdenuncianteCdepartdomic = this.persona.cpersonaCdepartdomic;
    this.fur.denunciante.cdenuncianteCprovdomic = this.persona.cpersonaCprovdomic;
    this.fur.denunciante.cdenuncianteCdistdomic = this.persona.cpersonaCdistdomic;
    this.fur.denunciante.cdenuncianteCreferenciadomic = this.persona.cpersonaDscreferencia;
    this.fur.denunciante.cdenuncianteDsccorreo = this.persona.cpersonaDsccorreo;
    this.fur.denunciante.cdenuncianteDsctelef = this.persona.cpersonaDsctelef;
    this.fur.denunciante.cdenuncianteDscmovil = this.persona.cpersonaDscmovil;
    this.fur.denunciante.ndenuncianteIdtipden = nfurIdtipdenun;

    // console.log("====vIdMedioNotif",vIdMedioNotif);

    this.fur.denunciante.ndenuncianteIdmedionotif = vIdMedioNotif;
    this.fur.denunciante.cdenuncianteFlgautemail = ConvertirFlag(flgAutorizoEmail);
    this.fur.denunciante.cdenuncianteFlgautacto = ConvertirFlag(flgAutorizoActo);
    // this.fur.denunciante.cdenuncianteDscagrup = dscNomAgrup;
    this.fur.denunciante.cdenuncianteFlgreprelegal = ConvertirFlag(flgRepreLegalPJ);
    this.fur.denunciante.ndenuncianteIdrangoedad = vNumIdRangoEdad;

    this.fur.denunciante.cdenuncianteCodsexo = vCodSexo;
    this.fur.denunciante.cdenuncianteFlgservpub = vFlgServPub;
    this.fur.denunciante.cdenuncianteFlgtestigoh = vFlgTestigoH;
    this.fur.denunciante.cdenuncianteFlgaccdirinf = vFlgAccDir;
    this.fur.denunciante.cdenuncianteDscenterohecho = vDscEnteroH;
    this.fur.denunciante.cdenuncianteCodmodopresent = vCodModoPresent;

    this.fur.denunciante.cdenuncianteCdeptent = vCodDepartEnt;
    this.fur.denunciante.cdenuncianteCprovent = vCodProvEnt;
    this.fur.denunciante.cdenuncianteCdistent = vCodDistEnt;
    this.fur.denunciante.cdenuncianteDscdireccent = vCodDireccEnt;
    this.fur.denunciante.cdenuncianteDscrefcent = vCodReferenEnt;

    this.fur.denunciante.cdenuncianteCodentcompl = vCodEntidadCompl;
    // this.fur.denunciante.cdenuncianteDscotroscompl = vDscOtrosCompl;

    this.fur.denunciante.listaDenunciantePorReplegal = vListDenuncXRL;

    // console.log("===========guardar 5");

    // COMPLEMENTO

    // this.fur.denunciante.cdenuncianteDscrefdomccompl = vDscRefDomicCompl;

    if (this.personaCompl != null) {

      this.fur.denunciante.personaComplemento = this.personaCompl;
      this.fur.denunciante.cdenuncianteDsccorreocompl = this.personaCompl.cpersonaDsccorreo;
      this.fur.denunciante.cdenuncianteDsctelefcompl = this.personaCompl.cpersonaDsctelef;
      this.fur.denunciante.cdenuncianteDscmovilcompl = this.personaCompl.cpersonaDscmovil;
      this.fur.denunciante.cdenuncianteDscdirecccompl = this.personaCompl.cpersonaDscdireccion;

    }

    if (vDenuncianteCompl != null) {

      this.fur.denunciante.cdenuncianteDscdirecccompl = vDenuncianteCompl.cdenuncianteDscdirecccompl;
      this.fur.denunciante.cdenuncianteCdepartcompl = vDenuncianteCompl.cdenuncianteCdepartcompl;
      this.fur.denunciante.cdenuncianteCprovcompl = vDenuncianteCompl.cdenuncianteCprovcompl;
      this.fur.denunciante.cdenuncianteCdistcompl = vDenuncianteCompl.cdenuncianteCdistcompl;
      this.fur.denunciante.cdenuncianteDscrefdomccompl = vDenuncianteCompl.cdenuncianteDscrefdomccompl;
      this.fur.denunciante.cdenuncianteDscagrup = vDenuncianteCompl.cdenuncianteDscagrup;
      this.fur.denunciante.cdenuncianteFlgsinruc = vDenuncianteCompl.cdenuncianteFlgsinruc;

    }

    // Revisar : GSOLIS
    // this.fur.denunciante.cdenuncianteDscagrup = dscAgrupacion;
    // console.log("===========guardar 8");

    // Notificacion de correo - GSOLIS
    this.contenedorDenuncianteC.email.cbpmmaildetDestinatario = this.persona.cpersonaDsccorreo;
    this.contenedorDenuncianteC.email.cbpmmaildetRemitente = correoEmisor;
    this.fur.correoDetalle = this.contenedorDenuncianteC.email;


  } else {

    if (this.flgActivaEncuesta) {

      if (this.fur.denunciante == null) {this.fur.denunciante = new Denunciante(); }

      vDenuncianteAnonimo = this.contenedorDenuncianteC.encuestaC.getEncuestaDenunciante();

      this.fur.denunciante.cdenuncianteFlgservpub = vDenuncianteAnonimo.cdenuncianteFlgservpub;
      this.fur.denunciante.cdenuncianteFlgtestigoh = vDenuncianteAnonimo.cdenuncianteFlgtestigoh;
      this.fur.denunciante.cdenuncianteFlgaccdirinf = vDenuncianteAnonimo.cdenuncianteFlgaccdirinf;
      this.fur.denunciante.cdenuncianteDscenterohecho = vDenuncianteAnonimo.cdenuncianteDscenterohecho;

      this.fur.denunciante.cdenuncianteFlganonimo = vDenuncianteAnonimo.cdenuncianteFlganonimo;
      this.fur.denunciante.ndenuncianteIdtipden = vDenuncianteAnonimo.ndenuncianteIdtipden;
      this.fur.denunciante.ndenuncianteIdrangoedad = vDenuncianteAnonimo.ndenuncianteIdrangoedad;
      this.fur.denunciante.cdenuncianteCodsexo = vDenuncianteAnonimo.cdenuncianteCodsexo;

    } else {


      this.fur.denunciante = null;

    }



  }

   // console.log("===========guardar 10");

  if (flgSolicMP) {

     // MP
    flgAceptoMP = this.contenedorMpC.flgAcepto;
    flgConfirmaSolMP = this.contenedorMpC.flgSolicita;

    this.fur.denunciante.cdenuncianteFlgconfleyprot = ConvertirFlag(flgConfirmaSolMP);
    this.fur.denunciante.cdenuncianteFlgacepmedpyb = ConvertirFlag(flgAceptoMP);

  }

  this.fur.cfurCodent = entidadSelec.centCodigo;
  this.fur.cfurCdepent = cfurCdepent;

  this.fur.cfurCdistent = cfurCdistent;
  this.fur.cfurCprovent = cfurCprovent;
  this.fur.cfurDscrefentidad = cfurDscrefentidad;
  this.fur.nombreEntidad = nombreEntidad;

  this.fur.otroTipoHecho = vHechoIrregular.otroTipo;
  this.fur.cfurDirentidad = cfurDirentidad;
  this.fur.nfurIdmacroproceso = nfurIdmacroproceso;

  this.fur.nfurIdcanal = gvCanal.NumFormWeb;

  this.fur.cfurFlgdirocuhecho = vEntidadHechoC.getStringDireccionHechos();
  this.fur.cfurDschecho = cfurDschecho;

  this.fur.cfurFlgexismonto = flgPerjuicioEco;
  this.fur.cfurFlgemontodesc = flgMontoDesc;


  this.fur.cfurFlghdenconocu = ConvertirFlag(flgHechoContOcu);
  this.fur.cfurFlgprecisa = ConvertirFlagPre(flgHechoprecisa);
  this.fur.strDfurFeciniperiodo = strFechaIniPer;
  this.fur.strDfurFecfinperiodo = strFechaFinPer;


  this.fur.cfurFlgdatfuninv = ConvertirFlag(flgConoceFun);
  this.fur.cfurFlgexispruh = ConvertirFlag(flgPruebas);
  this.fur.cfurFlgreqidentif = ConvertirFlag(flgReqIdent);
  this.fur.nfurImpmontoperj = nfurImpmontoperj;

  this.fur.cfurFlgreqidentif = ConvertirFlag(flgReqIdent);

  this.fur.cfurFlgotrentinst = ConvertirFlag(flgOtrInst);

  this.fur.cfurFlgpruebahechos = ConvertirFlag(flgPruebas);
  this.fur.archivosAlfresco = archivosAlfresco;

  this.fur.strDfurFecregistro = GetDateTime(0, 0);
  this.fur.strDfurFecinicioreg = fechaHoraString; // ConvertDateTimeToStrForBD(new Date(fechaHoraString));//GetDateTimeString(fechaHoraString);

  this.fur.nfurIdnumotr1 = numIdInstanciaExt;

  if (this.flgGuardarBorrador && vFlgNuevoFw) {

    this.fur.strDfurFchrecep = GetDateTime(this.numDiasVencimiento, 1);

  }

  this.fur.nfurIdestado = Number(estadoFormulario);
  this.fur.nfurIdestadoformulario = Number(estadoFormulario);


  cantTotalReg = listObraPub.length;

  if (cantTotalReg > 0) {

    this.fur.listaFurPorObraPublica = [];

  }

  for (let index = 0; index < cantTotalReg; index++) {

      this.fur.listaFurPorObraPublica[index] = new FurXObraPublica();
      this.fur.listaFurPorObraPublica[index] = listObraPub[index];

  }

  cantTotalReg = listContratacion.length;

  if (cantTotalReg > 0) {

    this.fur.listaFichaPorContratacion = [];

  }

  for (let index = 0; index < cantTotalReg; index++) {

      this.fur.listaFichaPorContratacion[index] = new FichaXContratacion();
      this.fur.listaFichaPorContratacion[index] = listContratacion[index];

  }

  cantTotalReg = listDenunciado.length;

  if (cantTotalReg > 0) {

    this.fur.listaDenunciadoPorFicha = [];

  }

  listDenunciado.forEach(denunciado => {
      const denunciadoFicha = new DenunciadoXFicha();
      denunciadoFicha.cdciadoxfichaCodtipo = 'FUR';
      denunciadoFicha.denunciado = denunciado;
      this.fur.listaDenunciadoPorFicha.push(denunciadoFicha);
  });


  // console.log("=O====================11");
  cantTotalReg = listEmpresa.length;

  if (cantTotalReg > 0) {

    this.fur.listaFurPorEmpresaInvolucrada = [];

  }

  // this.fur.ListaFurPorEmpresaInvolucrada = listEmpresa;
  for (let index = 0; index < listEmpresa.length; index++) {

    // console.log("=O====================11.0");
    this.fur.listaFurPorEmpresaInvolucrada[index] = new FURXEmpresaInvolucrada();

    // console.log("=O====================11.1");
    this.fur.listaFurPorEmpresaInvolucrada[index].persona = listEmpresa[index];

    // console.log("=O====================11.2");

  }

  // console.log("=O====================12");

  cantTotalReg = listEvidencias.length;

  if (cantTotalReg > 0) {

    this.fur.listaDocumentoAdjuntoDet = [];

  }


  this.fur.listaFichaPorInstancia = [];
  this.fur.listaFichaPorInstancia = instanciaC.instanciaList;

  if (idFurBase > 0) {
    this.fur.nfurIdbase = idFurBase;
    this.fur.cfurCodtipo = 'FUR';

  }

  if (usuarioSup != null) {
    this.fur.cfurIdususuperv = usuarioSup;
  }
  if (usuarioAsig != null) {
    this.fur.cfurIdusuasig = usuarioAsig;
  }
  if (this.fur.correoDetalle != null) {
    this.fur.correoDetalle.cbpmmailIdcodtip = this.fur.cfurCodtipo;
    this.fur.correoDetalle.nbpmmailIntento = 0;
    if (idFurBase > 0) {
      this.fur.correoDetalle.cbpmmailIdcodtip = 'FUR';
      this.fur.correoDetalle.cbpmmaildetAsunto = 'Registro de Formulario Virtual';
    } else {
      this.fur.correoDetalle.cbpmmaildetAsunto = 'Registro de FUR';
    }


  }

  if (estadoFurEval != null) {
    if (estadoFurEval == NumIdEstadoHeEvaluacionSuperv || estadoFurEval == NumIdEstadoHeEvaluacionObservado) {
        this.fur.nfurIdestado = estadoFurEval;
    }
  }

  // CUS 04 - 06
  if (this.contenedorMpC != null) {
    if (this.contenedorMpC.flgEsFur && this.contenedorMpC.expedienteC.listaExpediente.length > 0) {
      this.fur.listaFichaExpediente = this.contenedorMpC.expedienteC.listaExpediente;
    }
  }

  // console.log("=O====================13");
  // console.log(this.fur);
  // console.log(JSON.stringify(this.fur));

  this.spinner.show();

  if (vFlgNuevoFw) {

    // console.log("=O====================NUEVOOOOOOOO");

    this.furService.RegistrarFur(this.fur).subscribe(
      data => {

        //this._postTransaccion(data, flgPruebas);
        // JCMF
        console.log(data);
        this.spinner.hide();
        return;

      },
      err => {

        this.spinner.hide();
        console.log(err);

      }
      );

    } else {

      this.furService.ActualizarFur(this.fur).subscribe(
        data => {

          //this._postTransaccion(data, flgPruebas);

          return;

        },
        err => {

          this.spinner.hide();
          console.log(err);

        }
        );


    }

    // this.strDscMensajeSpinner = DscMensajeSpinner;

  }

  _CambiarTextoSpinner(numCaso: number) {

    switch (numCaso) {
      case 1:

        this.strDscMensajeSpinner = DscMensajeSpinner;

        break;
      case 2:

        //this.strDscMensajeSpinner = DscMensajeSpinner2;
        this.strDscMensajeSpinner = DscMensajeSpinner;
        break;

      default:
        break;
    }



  }

  _postTransaccion(furNew: Fur, flgPruebas: boolean) {

    // vFurNew = data;

    // this.spinner.hide();

    const vIdFur = furNew.nfurId;
    // var vCorreoBpm:CorreoBpm = new CorreoBpm();
    // var vDscCorreoDenunc:string = furNew.denunciante.cdenuncianteDsccorreo;

    if (vIdFur > 0) {

      if (flgPruebas) {



      } else { // SI NO CUENTA CON PRUEBAS

        if (this.flgEnviarDenuncia) {

          this._postProcesoEnvioDenuncia(furNew);

        } else {

          // this._terminaGuardar(furNew);
          this._postProcesoBorrador(furNew);

        }

        // this._terminaGuardar(furNew);

      }



    } else {

      openModalMensaje('Formulario Virtual', 'Ocurrió un problema en la actualización del registro', this.dialog);

    }

    // if(this.flgEnviarDenuncia)
    // {

    //   this._generaOficio(vIdFur);

    // }

  }

  _postProcesoBorrador(furNew: Fur) {

    // var vGeneral:General = new General();

    // this.spinner.show();

    this._envioCorreo(furNew, true);

    this._generarPlantilla(furNew.nfurId, furNew, false).subscribe(data => {

      // console.log("=============plantilllllaaa")
      // console.log(data);

      // this.spinner.hide();

      // vGeneral = data;

      this._habilitarCamposFur();

      this._terminaGuardar(furNew, data);

    });

  }


  _envioCorreo(fur: Fur, boolFlgEnvBorr: boolean) {

    // let claveDenunc:string = "";
    const correoBpm: CorreoBpm = new CorreoBpm();
    let dscCorreoDenunc = '';
    let strMensaje = '';
    let strMensaje2 = '';

    if (fur.denunciante) {

      dscCorreoDenunc = fur.denunciante.cdenuncianteDsccorreo;

    }

    if (isNotEmpty(dscCorreoDenunc)) {

      if (boolFlgEnvBorr) {

        strMensaje2 = `<p><i><span style=\"font-family: Century Gothic, CenturyGothic;\">Para continuar con el registro de su Alerta Ciudadana, debe ingresar a “Accede a tu denuncia” con el código  <b style=\"color:red;\">${fur.cfurCodborrador}</b> y la clave <b style=\"color:red;\">${fur.cfurClavedenunc}</b> a través del <b><a href='${this.strDscEnlaceApp}'>"Formulario de denuncias"</a></b><br></span></i></p></div>\r\n`;

      } else {

        strMensaje2 = `<p><i><span style=\"font-family: Century Gothic, CenturyGothic;\">Asimismo, es preciso informarle que el envío de su Alerta Ciudadana, no implica su aceptación a trámite, lo cual está sujeto al cumplimiento de las disposiciones y requisitos establecidos en el numeral 6.4.2. de la <b><a href='${this.strDscEnlaceDocEmail}'>Directiva N° 009-2020-CG/GCSD Recepción. Evaluación y Atención de Denuncias.</a></b> aprobada mediante Resolución de Contraloría N° 206-2020-CG, de 14 de julio de 2020.<br></span></i></p></div>\r\n` +
        `<p><i><span style=\"font-family: Century Gothic, CenturyGothic;\">Para el seguimiento del estado situacional de la Alerta Ciudadana, debe consultar con el código <b style=\"color:red;\">${fur.cfurCodborrador}</b> y la clave <b style=\"color:red;\">${fur.cfurClavedenunc}</b> a través del aplicativo móvil <b><a href='${this.strDscEnlaceApp}'>"Estado de Alertas Ciudadanas"</a></b><br></span></i></p></div>\r\n`;

      }


      strMensaje = recupContenidoEmail(
      '<p><i><span style="font-family: Century Gothic, CenturyGothic;">La OEFA, agradece su colaboración en la lucha contra la corrupción y su interés por el uso correcto, eficiente y transparente de los recursos y bienes del Estado<br></span></i></p></div>\r\n' +
      '<p><i><span style="font-family: Century Gothic, CenturyGothic;">Toda la información que ha registrado, se encuentra protegida por el principio de reserva, en aplicación de lo dispuesto en el literal n) de los artículos 9° y 22° de la Ley N° 27785 Ley Orgánica del Sistema Nacional de Control y de la OEFA.<br></span></i></p></div>\r\n' +
      strMensaje2 +
      '<p><i><span style="font-family: Century Gothic, CenturyGothic;">De requerir mayor información respecto a la tramitación de las Alertas Ciudadanas, puede comunicarse al número 330 3000 Anexos 1305 y 1307.<br></span></i></p></div>\r\n'
      );

      correoBpm.listaMailDetalle = [];
      correoBpm.listaMailDetalle[0] = new CorreoDetalleBpm();
      correoBpm.listaMailDetalle[0].cbpmmaildetAsunto = 'Notificación de registro de Alerta Ciudadana';
      // correoBpm.listaMailDetalle[0].cbpmmaildetContenido = "Se registró el Nro. Formulario Virtual " + fur.cfurCodborrador + claveDenunc;
      correoBpm.listaMailDetalle[0].cbpmmaildetContenido = strMensaje;
      correoBpm.listaMailDetalle[0].cbpmmaildetDestinatario = dscCorreoDenunc;

      // console.log("==========vCorreoBpm");
      // console.log(JSON.stringify(correoBpm));

      this.externosService.registrarDatosCorreo(correoBpm).subscribe(data => {

        if (data != null) {

          console.log('Correo Remitido Correctamente');

        }

      },
      err => {
        console.log(err);
      });

    }

  }

  _postProcesoEnvioDenuncia(furNew: Fur) {

    const vIdFur = furNew.nfurId;
    const idCanal = furNew.nfurIdcanal;
    const strCodFur = furNew.cfurCodigo;

    let generalPlant: General = new General();

    const requestNewInstanceGC: RequestNewInstanceGC = new RequestNewInstanceGC();

    const cuniCodigo = this.denunciaContenedorC.entidadHechoC.cuniCodigo;

    requestNewInstanceGC.intIdFurHI = vIdFur;
    requestNewInstanceGC.intIdFurHICanal = idCanal;
    requestNewInstanceGC.strCodFurHI = strCodFur;
    requestNewInstanceGC.numFormulario = furNew.cfurCodborrador;
    requestNewInstanceGC.canal = 'Formulario Virtual';
    requestNewInstanceGC.unidad = cuniCodigo;

    if (this.denunciaContenedorC.entidadHechoC) {

      const removeAccents = (str) => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      };

      requestNewInstanceGC.entidadInvolucrada = removeAccents(this.denunciaContenedorC.entidadHechoC.nombreEntidad);

    }

    requestNewInstanceGC.tipoDenunciante = (furNew.denunciante.cdenuncianteFlganonimo == 'SI' ? 'Anonimo' : 'Persona Natural') ;

    this._envioCorreo(furNew, false);

    // SE COMENTA POR QUE NO FUNCIONA EL SERVICIO
    // this.spinner.show();
    this._generarPlantilla(furNew.nfurId, furNew).subscribe(data => {

      generalPlant = data;

    });


  }

  _generaOficio(idFur: number) {

    // this.flgDeshabilitaGuardar = true;
          // this.guardarEmitter.emit(this.flgDeshabilitaGuardar);
    this.oficio.rutaArchivoPlantilla = 'C:\\\\archivos\\\\';
    this.oficio.nombreArchivoPlantilla = 'OFICIO.DOCX';
    this.oficio.rutaArchivoGenerado = 'C:/archivos/';
    this.oficio.nombreArchivoGenerado = 'oficioGeneradoCGR.docx';
    this.oficio.asunto = 'Formulario Virtual  N° ' + idFur;
    this.oficio.cargo = 'Ciudadano';
    this.oficio.cargo_EMP_ENC = 'ANALISTA';
    this.oficio.contenido = 'En ese sentido, en virtud a lo dispuesto en el artículo 8° de la Ley N° 29542 “Ley de Protección al Denunciante en el Ámbito Administrativo y de Colaboración Eficaz en el Ámbito Penal” y en el artículo 10° de su reglamento, aprobado mediante Decreto Supremo N° 038-2011-PCM, los cuales establecen la competencia del (Ministerio del Trabajo y Promoción del Empleo / las Direcciones Regionales de Trabajo y Promoción del Empleo) para realizar inspecciones laborales cuando el trabajador denunciante es objeto de represalias que se materializan en actos de hostildad, independientemente del régimen laboral en el que se encuentre ; se remite a su Despacho, fotocopia de la documentación alcanzada por el mencionado por el mencionado denunciante, en los folios, para las acciones correspondientes y posterior remisión a este Órgano Superiror de Control de la actas o informes conteniendo el resultado de la actuación de inspección, en cumplimiento de lo señalado en el literal e) del artículo 10° del mencinado reglamento.';
    this.oficio.datos_EMISION_CGR = 'CGR-123456';
    this.oficio.des_ENTIDAD = 'SUNAT';
    this.oficio.direccion_DESTINATARIO = 'MZ. C13 LT. 34 Bocanegra-Callao';
    this.oficio.empleado_EMITE = 'Congresita';
    this.oficio.iniciales_EMP =  'USIL';
    this.oficio.nombre_ANIO = 'DAVC-1993';
    this.oficio.nombre_DESTINATARIO = 'Alexander Valderrama';
    this.oficio.pie_PAGINA = 'General';
    this.oficio. post_FIRMA = 'Firmado',
    this.oficio.referencia = 'http://192.168.0.1:9000/Hola Mundo';
    this.oficio.sigla_DOC = 'ASDQWEZXC-123456';
    this.oficio.ubigeo_DESTINATARIO = 'Lima-San Isidro-Navarrete';
    this.oficio.uuoo_DESTINO = 'SUNAT';



  }

  _terminaGuardar(fur: Fur, rptaDocumento?: General) {

    this.spinner.hide();

    // console.log("==============rptaDocumento",rptaDocumento);

    let vDscTitulo = '';
    let vDscMensaje = '';
    const vCodBorrador = fur.cfurCodborrador;
    const vModalMensaje: ModalMensaje = new ModalMensaje();
    const vDocumento: string = ( rptaDocumento ? rptaDocumento.dscCampo1 : '');
    const vFlgBase64: boolean = ( rptaDocumento ? rptaDocumento.flgCampo1 : null);
    const boolFlgBorrador: boolean = this.flgGuardarBorrador;
    const numCasoRouter: number = (boolFlgBorrador ? 5 : 4);
    // let strHeight:string = (boolFlgBorrador ? '80%': '70%');

    // vDscTitulo = "¡Muchas Gracias por registrar su denuncia!";
    vDscTitulo = 'Denuncia registrada ' + (boolFlgBorrador ? 'en borrador' : '');
    vDscMensaje = 'La misma que se ha registrado con el código : ' + vCodBorrador;

    vModalMensaje.titulo = vDscTitulo;
    vModalMensaje.mensaje = vDscMensaje;
    vModalMensaje.fur = fur;
    vModalMensaje.fur.listaDocumentoAdjuntoDet = [];
    vModalMensaje.general = new General();
    vModalMensaje.general.flgCampo1 = boolFlgBorrador;
    vModalMensaje.general.dscCampo1 = vDocumento;
    vModalMensaje.general.flgCampo2 = vFlgBase64;

    // openModalMensaje(vDscTitulo,vDscMensaje,this.dialog);

    GlobalVars.objetoRegExitoso = vModalMensaje;
    // GlobalVars.FlgRegExitoso = !this.flgGuardarBorrador; // TRUE

    cookieGlobalVars(5);

    this._CambiarTextoSpinner(1);
    cambiarRouter(this.router, numCasoRouter);

    // this.datosGeneralC.setDatosGenerales(fur);

    // if(this.flgGuardarBorrador == false)
    // {



    // }else{

    //     // MENSAJE DE GUARDADO ESPECIAL
    //   const dialogRef = this.dialog.open(ModalGuardarComponent,{ width: '75%',height: strHeight,
    //   data: vModalMensaje });

    //   dialogRef.afterClosed().subscribe(result => {

    //     this._CambiarTextoSpinner(1);


    //   });


    // }

    this._postTerminarGuardar(fur);

  }

  _postTerminarGuardar(fur: Fur) {

    this.flgViewDatosGen = true;

    if (this.flgGuardarBorrador == true) {

      this.spinner.show();

      const frmFURPorCodigoBorrador = new FrmFURPorCodigoBorrador();

      frmFURPorCodigoBorrador.cfurCodborrador = fur.cfurCodborrador;
      frmFURPorCodigoBorrador.cfurFecinicioreg = fur.strDfurFecinicioreg.substr(0, 10);
      frmFURPorCodigoBorrador.cfurClavedenunc = fur.cfurClavedenunc;

      this.furService.obtenerFurPorCodigoBorrador(frmFURPorCodigoBorrador).subscribe(

        data => {

          // this.verFormularioWeb(data,false);
          this.flgDeshabilitaGuardar = true;
          data.flgRecupBorrador = true;

          this.guardarEmitter.emit(data);

          this.spinner.hide();



        }
        ,
        err => {

          this.spinner.hide();
          console.log(err);

        }
        );


    } else {

      // setTimeout(() => {

      //   console.log("=======setDatosGenerales111");

      // this.datosGeneralC.setDatosGenerales(fur);

      // }, 1);

      this.flgDeshabilitaGuardar = true;

      this.guardarEmitter.emit(fur);


    }


  }


  guardarBorrador() {

    // if(this.datosGeneralC ==)

    this.datosGeneralC.getNroFormularioWeb();

    // this.contenedorDenuncianteC.contenedorDenuncianteReadEnable();


  }




  deshabilitarCamposFur() {

    let vFlgAnonimo = false;
    let flgDeshEvidencia = false;

    // console.log("============0deshabilitarCamposFur");

    this.denunciaContenedorC.entidadHechoC.entidadComponentReadEnable();
    this.denunciaContenedorC.hechoIrregularC.hechoIrregularCReadEnable();
    this.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.funcionarioCReadEnable();
    this.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.empresaCReadEnable();
    this.denunciaContenedorC.pruebaHechoC.pruebaHechoCReadEnable();
    this.denunciaContenedorC.denunciaContenedorCReadEnable();
    this.denunciaContenedorC.instanciaC.instanciaCReadEnable();

    // console.log("============1flgDeshEvidencia",flgDeshEvidencia);

    if (this.denunciaContenedorC.pruebaHechoC) {

      if (this.denunciaContenedorC.pruebaHechoC.evidenciaC || this.denunciaContenedorC.pruebaHechoC.cuenta_pruebas) {

        flgDeshEvidencia = true;

      }

    }

    // console.log("============0flgDeshEvidencia",flgDeshEvidencia);

    if (flgDeshEvidencia) {
      //this.denunciaContenedorC.pruebaHechoC.evidenciaC.evidenciaCReadEnable();
    }

      // Tab denunciante
    setTimeout(() => {

          if (this.denunciaContenedorC.requireIdentificarse) {
            this.contenedorDenuncianteC.contenedorDenuncianteReadEnable();

            if (this.contenedorDenuncianteC.flgSolicMP) {
              // console.log(" :3 : " + this.contenedorDenuncianteC.denunciante.cdenuncianteFlgmedidaprotec);

              setTimeout(() => {
                this.contenedorMpC.medidaProteccionCReadEnable();
                // this.formularioCmp.contenedorMpC.medidaProteccionCReadEnable();

              }, 0);

            }

          } else {

            if (this.fur.denunciante) {

              vFlgAnonimo = getBooleanFlag(this.fur.denunciante.cdenuncianteFlganonimo);

            }

            if (this.contenedorDenuncianteC) {

              this.contenedorDenuncianteC.setFlgAnonimo(vFlgAnonimo);

              this.contenedorDenuncianteC.contenedorDenuncianteReadEnable();

            }

          }


      }, 0);

  }

  _habilitarCamposFur() {
    this.denunciaContenedorC.entidadHechoC.entidadComponentReadDisable();
    this.denunciaContenedorC.hechoIrregularC.hechoIrregularCReadDisable();
    this.denunciaContenedorC.hechoIrregularC.funcionarioInvolucradoC.funcionarioCReadDisable();
    this.denunciaContenedorC.hechoIrregularC.empresaInvolucradaC.empresaCReadDisable();
    this.denunciaContenedorC.pruebaHechoC.pruebaHechoCReadDisable();
    this.denunciaContenedorC.denunciaContenedorCReadDisable();
    this.denunciaContenedorC.instanciaC.instanciaCReadDisable();
    // this.formularioCmp.denunciaContenedorC.pruebaHechoC.evidenciaC.evidenciaCReadDisable();
    if (this.denunciaContenedorC.pruebaHechoC.cuenta_pruebas) {
     // this.denunciaContenedorC.pruebaHechoC.evidenciaC.evidenciaCReadEnable();
    }
      // Tab denunciante
    setTimeout(() => {
          if (this.denunciaContenedorC.requireIdentificarse) {
            this.contenedorDenuncianteC.contenedorDenuncianteReadDisable();
              // this.formularioCmp.contenedorDenuncianteC.contenedorDenuncianteReadEnable();


          // Tab medida de proteccion
            if (this.contenedorDenuncianteC.denunciante.cdenuncianteFlgmedidaprotec == 'SI') {

            setTimeout(() => {
              // this.formularioCmp.contenedorMpC.medidaProteccionCReadEnable();
              this.contenedorMpC.medidaProteccionCReadDisable();
            }, 0);

          }
        }


      }, 0);
  }

  imprimirPDF() {

        this.documentoCGR.rutaArchivoPlantilla = 'C:\\\\archivos\\\\';
        this.documentoCGR.nombreArchivoPlantilla = 'plantillaPrueba.dotx';
        this.documentoCGR.rutaArchivoGenerado = 'C:/archivos/';
        this.documentoCGR.nombrePdfGenerado = 'oficioGeneradoCGR.pdf';
        // this.documentoCGR.nombreArchivoGenerado = "oficioGeneradoCGR.docx";

        this.documentoCGR.datos = [];

        this.documentoCGR.datos[0] = new AtributoCGR();
        this.documentoCGR.datos[0].nombre = 'CodigoFur';
        this.documentoCGR.datos[0].valor = '155';





  }


  generarCodigoFur(fur: Fur) {
    let codigoGenerado = '';
    let codigoCorrelativo = '';
    let tamanioIdFur = 0;
    let stringIdFur = '';

    codigoCorrelativo = codigoIncial;
    stringIdFur = String(fur.nfurId);
    tamanioIdFur = stringIdFur.length;
    codigoCorrelativo  = codigoCorrelativo.slice(0, tamanioIdFur);
    codigoCorrelativo = codigoCorrelativo + stringIdFur;
    codigoGenerado = fur.cfurCodtipo  + '.' + anioActualGlobal + '.' + codigoCorrelativo + 'CGR'; // Verificar si OCI O CGR
    return codigoGenerado;
 }

 actualizarCodigo(codigo: string) {
   this.datosGeneralC.nro_formulario = codigo;
 }
}
